import React, { useState, useEffect, useMemo, useRef } from 'react';
import { withAuthenticator, Heading, SelectField, Flex, View, Text, Alert } from '@aws-amplify/ui-react';
import Tooltip from '@mui/material/Tooltip';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    Autocomplete,
    FormControlLabel,
    Switch,
    Select,
    MenuItem,
    Checkbox,
    InputLabel,
    FormControl,
    Divider,
    Grid,
    IconButton,
    Alert as MuiAlert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    ToggleButtonGroup,
    ToggleButton
} from '@mui/material';

import { useSearchParams } from 'react-router-dom';
import { 
    CheckCircle as CheckCircleIcon, 
    ArrowBack as ArrowBackIcon, 
    ArrowForward as ArrowForwardIcon, 
    Search as SearchIcon, 
    CloudUpload as CloudUploadIcon, 
    Refresh as RefreshIcon,
    Square as SquareIcon,
    Campaign as CampaignIcon,
    DeleteSweep as DeleteSweepIcon,
    GroupWork as GroupWorkIcon,
    ContentCopy as CloneIcon,
    Help as HelpIcon
} from '@mui/icons-material';
import moment from 'moment'; 
import CreateGameModal from '../components/CreateGameModal';
import AddToAnomalyListModal from '../components/AddToAnomalyListModal';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import CopyToClipboardText from '../ui-components/CopyToClipboardText';






import axios from 'axios';  //API call support
import { useGamesCache } from '../contexts/GamesContext';


const normalizeString = (str) => {
    return str ? str.trim().toLowerCase() : '';
};

const resizeImage = (file, maxWidth, maxHeight, quality = 0.8) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;

                if (width > maxWidth) {
                    height = Math.round((height * maxWidth) / width);
                    width = maxWidth;
                }
                if (height > maxHeight) {
                    width = Math.round((width * maxHeight) / height);
                    height = maxHeight;
                }

                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                resolve(canvas.toDataURL('image/jpeg', quality));
            };
            img.onerror = (err) => reject(err);
        };
        reader.onerror = (err) => reject(err);
    });
};


const TimeMachine = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const urlScanId = searchParams.get('scanId');
    const urlCountry = searchParams.get('country');
    const urlRegion = searchParams.get('region');
    const urlWebsiteId = searchParams.get('websiteId');
    const urlDate = searchParams.get('date');

    const [websiteCatalog, setWebsiteCatalog] = useState([]);
    const [catalogFilters, setCatalogFilters] = useState({ countries: [], regions: [], brands: [], operators: [] });
    const [selectedCountryFilter, setSelectedCountryFilter] = useState(urlCountry || 'all');
    const [selectedRegionFilter, setSelectedRegionFilter] = useState(urlRegion || 'all');
    const [selectedTagFilter, setSelectedTagFilter] = useState('all');
    
    const [targetScanId, setTargetScanId] = useState(urlScanId);
    const [isCatalogLoaded, setIsCatalogLoaded] = useState(false);
    const [showActiveOnly, setShowActiveOnly] = useState(process.env.REACT_APP_ENV !== 'dev');
    const selectedWebsiteId = urlWebsiteId || '';
    const [screenshots, setScreenshots] = useState([]);
    const [currentScreenshotIndex, setCurrentScreenshotIndex] = useState(0);
    const [loadingScreenshots, setLoadingScreenshots] = useState(false);
    const [error, setError] = useState('');
    const [analysisResults, setAnalysisResults] = useState(null);
    const [analysisStatus, setAnalysisStatus] = useState('');
    const [imageUrl, setImageUrl] = useState(''); // Store the signed URL for the current screenshot
    const { games, fetchGames, studios, fetchStudios } = useGamesCache();
    const [showPositions, setShowPositions] = useState(false); // Controls whether position data is shown

    // What's New Modal State
    const [whatsNewOpen, setWhatsNewOpen] = useState(false);
    const [language, setLanguage] = useState('en');

    useEffect(() => {
        const seen = localStorage.getItem('whats_new_seen_tm_v1');
        if (!seen) {
            setWhatsNewOpen(true);
        }
    }, []);

    const handleCloseWhatsNew = () => {
        setWhatsNewOpen(false);
    };

    const handleDontShowWhatsNew = () => {
        localStorage.setItem('whats_new_seen_tm_v1', 'true');
        setWhatsNewOpen(false);
    };

    // New state variables for the assign/delete dialog
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedBox, setSelectedBox] = useState(null);  // Bounding box the user clicked
    const [anomalyListModalOpen, setAnomalyListModalOpen] = useState(false);
    const [promptAnomalyList, setPromptAnomalyList] = useState(false);
    const [lastOriginalGameId, setLastOriginalGameId] = useState(null);
    const [searchGameName, setSearchGameName] = useState('');
    const [selectedGame, setSelectedGame] = useState(null);
    const [studioName, setStudioName] = useState('');
    const [isPromotionBox, setIsPromotionBox] = useState(false);
    const [brandPromotions, setBrandPromotions] = useState([]);
    const [promotionTypes, setPromotionTypes] = useState([]);
    const [loadingPromotions, setLoadingPromotions] = useState(false);
    const [promoSuggestions, setPromoSuggestions] = useState([]);
    const [translatedOcrText, setTranslatedOcrText] = useState('');
    const [isTranslating, setIsTranslating] = useState(false);
    const [isCreatingBox, setIsCreatingBox] = useState(false);

    const [selectedPromo, setSelectedPromo] = useState(null);
    const [searchPromoText, setSearchPromoText] = useState('');
    const [newPromoDialogOpen, setNewPromoDialogOpen] = useState(false);
    const [newPromoText, setNewPromoText] = useState('');
    const [newPromoType, setNewPromoType] = useState('Promotion');
    const [newPromoAssociatedGames, setNewPromoAssociatedGames] = useState([]);

    const newPromoAssociatedGamesObjects = useMemo(() => {
        return games.filter(g => newPromoAssociatedGames.includes(g.GameID));
    }, [games, newPromoAssociatedGames]);


    // New state variables for draw mode
    const [drawMode, setDrawMode] = useState(false);
    const [drawBoxType, setDrawBoxType] = useState('Game');
    const [startCoords, setStartCoords] = useState(null);
    const [currentCoords, setCurrentCoords] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [batchDeleteMode, setBatchDeleteMode] = useState(false);
    const [selectedBoxes, setSelectedBoxes] = useState([]);

    // Fetch unique game names from the games array - used to manage the autocomplete
    const uniqueGameNames = [...new Set(games.map((game) => game.Name))];

    const selectedWebsiteRecord = useMemo(
        () => websiteCatalog.find((site) => site.WebsitesDBID === selectedWebsiteId) || null,
        [websiteCatalog, selectedWebsiteId]
    );

    // Loading image spinner state
    const [imageLoading, setImageLoading] = useState(false);

    // Enhanced Popup State
    const [suggestions, setSuggestions] = useState({ matches: [] });
    const [newGameDialogOpen, setNewGameDialogOpen] = useState(false);
    const [newGameName, setNewGameName] = useState('');

    const [loadingSuggestions, setLoadingSuggestions] = useState(false);
    const [autoAdvance, setAutoAdvance] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [searchDialogOpen, setSearchDialogOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [navigationMode, setNavigationMode] = useState('unconfirmed'); // 'unconfirmed' | 'search'
    const [isChecked, setIsChecked] = useState(false); // New state for checked status
    const [uploadingManual, setUploadingManual] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [groupNameDialogOpen, setGroupNameDialogOpen] = useState(false);
    const [groupNameAutocompleteOpen, setGroupNameAutocompleteOpen] = useState(false);
    const [newGroupBox, setNewGroupBox] = useState(null);
    const [promotionDialogOpen, setPromotionDialogOpen] = useState(false);
    const [newPromoBox, setNewPromoBox] = useState(null);
    const [isCloning, setIsCloning] = useState(false);
    const groupNameInputRef = useRef(null);
    const mainPromoInputRef = useRef(null);
    const activeDataIdRef = useRef('');

    useEffect(() => {
        if (groupNameDialogOpen || (dialogOpen && isPromotionBox)) {
            // Short delay to ensure the dialog transition has started
            const timer = setTimeout(() => {
                if (groupNameDialogOpen && groupNameInputRef.current) {
                    groupNameInputRef.current.focus();
                } else if (dialogOpen && isPromotionBox && mainPromoInputRef.current) {
                    mainPromoInputRef.current.focus();
                }
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [groupNameDialogOpen, dialogOpen, isPromotionBox]);

    // Robust data access helpers for marshalled (DDB) and unmarshalled data
    const getBBValue = (box, field) => {
        if (!box || !box.BoundingBox) return 0;
        const bb = box.BoundingBox;
        // Case 1: bb is marshalled as a Map { M: { Left: { N: "0.1" } ... } }
        if (bb.M && bb.M[field]) return parseFloat(bb.M[field].N || bb.M[field].S) || 0;
        // Case 2: bb is an object with marshalled fields { Left: { N: "0.1" } ... }
        if (bb[field] && typeof bb[field] === 'object' && (bb[field].N || bb[field].S)) return parseFloat(bb[field].N || bb[field].S) || 0;
        // Case 3: bb is a plain object { Left: 0.1 ... }
        if (bb[field] !== undefined) return parseFloat(bb[field]) || 0;
        return 0;
    };

    const getSVal = (obj, field) => {
        if (!obj) return '';
        const val = obj[field];
        if (!val) return '';
        if (val.S) return val.S;
        if (typeof val === 'string') return val;
        // Handle marshalled maps if field is nested
        if (val.M && val.M[field]) return getSVal(val.M, field);
        return '';
    };

    const getLVal = (obj, field) => {
        if (!obj) return [];
        const val = obj[field];
        if (!val) return [];
        if (val.L) return val.L.map(item => item.S || item);
        if (Array.isArray(val)) return val;
        return [];
    };

    const handleManualUpload = async (file) => {
        if (!file || !currentScreenshot) return;

        const screenshotId = currentScreenshot.id?.S || currentScreenshot.id;
        setUploadingManual(true);
        setError('');

        try {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                const base64 = reader.result;

                try {
                    let uploadBase64 = base64;
                    const estimatedSizeInBytes = (base64.length * 3) / 4;
                    console.log(`📡 Original Image size: ${(estimatedSizeInBytes / (1024 * 1024)).toFixed(2)} MB`);

                    // If image is large (> 4MB or highly resolved), resize it to fit Rekognition limits
                    if (estimatedSizeInBytes > 4 * 1024 * 1024) {
                        console.log('🔄 Image size > 4MB, resizing to max 4096px...');
                        uploadBase64 = await resizeImage(file, 4096, 4096, 0.85);
                        const newSize = (uploadBase64.length * 3) / (4 * 1024 * 1024);
                        console.log(`✅ Resized to: ${newSize.toFixed(2)} MB`);
                    }

                    console.log('📡 Fetch URL:', `${process.env.REACT_APP_API_URL}/screenshots/manual`);
                    console.log('📡 API Key present:', !!process.env.REACT_APP_API_KEY);

                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/screenshots/manual`, {
                        WebsitesDataID: screenshotId,
                        ImageBase64: uploadBase64
                    }, {
                        headers: {
                            'x-api-key': process.env.REACT_APP_API_KEY,
                            'Content-Type': 'application/json'
                        }
                    });


                    console.log('Manual upload success:', response.data);
                    
                    // Refresh the local screenshots array to reflect the new status/image
                    const updatedScreenshots = [...screenshots];
                    const index = updatedScreenshots.findIndex(s => (s.id?.S || s.id) === screenshotId);
                    if (index !== -1) {
                        updatedScreenshots[index].ScreenshotStatus = { S: 'PENDING_MANUAL' };
                        updatedScreenshots[index].ImageLocation = { S: response.data.ImageLocation };
                        // Clear existing analysis locally as it's been deleted in Brazilia
                        setAnalysisResults([]);
                        setAnalysisStatus('Pending overnight analysis');
                    }
                    setScreenshots(updatedScreenshots);

                    
                    // Refresh the image view
                    await fetchImageUrl(response.data.ImageLocation);
                    
                } catch (err) {
                    console.error('Error uploading manual screenshot:', err);
                    setError('Failed to upload manual screenshot: ' + (err.response?.data?.error || err.message));
                } finally {
                    setUploadingManual(false);
                }
            };
            reader.onerror = (err) => {
                console.error('FileReader error:', err);
                setError('Failed to read file');
                setUploadingManual(false);
            };
        } catch (err) {
            console.error('Manual upload error:', err);
            setError('An error occurred during upload');
            setUploadingManual(false);
        }
    };




    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch everything in parallel
                const promises = [
                    fetchWebsiteCatalog(),
                    fetchGames(),
                    fetchStudios()
                ];
                
                if (targetScanId) {
                    promises.push(
                        axios.get(`${process.env.REACT_APP_API_URL}/screenshots/${targetScanId}`, {
                            headers: { 'x-api-key': process.env.REACT_APP_API_KEY },
                        }).then(res => {
                            const item = res.data;
                            // Checking both WebsitesDBID and WebsiteID accounts for schema variations
                            const siteId = item.WebsitesDBID?.S || item.WebsitesDBID || item.WebsiteID?.S || item.WebsiteID;
                            if (siteId) {
                                setSearchParams(prev => {
                                    const newParams = new URLSearchParams(prev);
                                    newParams.set('websiteId', siteId);
                                    return newParams;
                                }, { replace: true });
                            }
                        }).catch(err => {
                            console.error("Failed to fetch deep link initial scanId details", err);
                        })
                    );
                }

                await Promise.all(promises);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsCatalogLoaded(true);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Listen for cross-tab commands (e.g. from Audit page)
    useEffect(() => {
        const channel = new BroadcastChannel('sao_paulo_time_machine');
        channel.onmessage = (event) => {
            if (event.data.type === 'LOAD_SCAN') {
                const { scanId, websiteId, date } = event.data;
                console.log('📡 Received LOAD_SCAN via channel:', event.data);
                
                // Try to focus this window
                window.focus();

                const newParams = {};
                for (const [key, value] of searchParams.entries()) {
                    newParams[key] = value;
                }
                if (websiteId) newParams.websiteId = websiteId;
                if (date) newParams.date = date;
                if (scanId) {
                    newParams.scanId = scanId;
                } else {
                    delete newParams.scanId;
                }
                setSearchParams(newParams);
            }
        };
        return () => channel.close();
    }, [setSearchParams, searchParams]);

    // DIALOG BOX HANDLERS
    //A series of handlers to manage the delete and assign game functions coming from the dialog box

    // Sort unconfirmed boxes by Top (vertical) then Left (horizontal)
    const getSortedUnconfirmedBoxes = () => {
        if (!analysisResults) return [];
        return analysisResults
            .filter(box => {
                const status = getSVal(box, 'Status');
                return status !== 'COMPLETE' && status !== 'PROMOTION';
            })
            .sort((a, b) => {
                const topA = parseFloat(a.BoundingBox?.M?.Top?.N || 0);
                const topB = parseFloat(b.BoundingBox?.M?.Top?.N || 0);
                if (Math.abs(topA - topB) > 0.05) { // Threshold for "same row"
                    return topA - topB;
                }
                const leftA = parseFloat(a.BoundingBox?.M?.Left?.N || 0);
                const leftB = parseFloat(b.BoundingBox?.M?.Left?.N || 0);
                return leftA - leftB;
            });
    };

    const handleNextUnconfirmed = () => {
        let listToNavigate = [];
        if (navigationMode === 'search') {
            listToNavigate = searchResults;
        } else {
            listToNavigate = getSortedUnconfirmedBoxes();
        }

        if (listToNavigate.length === 0) return;

        const currentIndex = listToNavigate.findIndex(b => b.BoundingBoxID?.S === selectedBox?.BoundingBoxID?.S);
        const nextIndex = (currentIndex + 1) % listToNavigate.length;
        handleBoxClick(listToNavigate[nextIndex]);
    };

    const handlePreviousUnconfirmed = () => {
        let listToNavigate = [];
        if (navigationMode === 'search') {
            listToNavigate = searchResults;
        } else {
            listToNavigate = getSortedUnconfirmedBoxes();
        }

        if (listToNavigate.length === 0) return;

        const currentIndex = listToNavigate.findIndex(b => b.BoundingBoxID?.S === selectedBox?.BoundingBoxID?.S);
        const prevIndex = (currentIndex - 1 + listToNavigate.length) % listToNavigate.length;
        handleBoxClick(listToNavigate[prevIndex]);
    };

    const handleBoxClick = (box, force = false) => {
        if (force) {
            setDrawMode(false);
            setBatchDeleteMode(false);
        } else {
            // Allow clicking GameGroup boxes even in Draw Mode (if it's the right type)
            const isGroupClick = drawMode && drawBoxType === 'GameGroup' && getSVal(box, 'BoxType') === 'GameGroup';
            if (drawMode && !isGroupClick) return; 
            if (batchDeleteMode) {
                const boxId = box.BoundingBoxID?.S || box.BoundingBoxID;
                const isSelected = selectedBoxes.some(b => (b.BoundingBoxID?.S || b.BoundingBoxID) === boxId);
                if (isSelected) {
                    setSelectedBoxes(selectedBoxes.filter(b => (b.BoundingBoxID?.S || b.BoundingBoxID) !== boxId));
                } else {
                    setSelectedBoxes([...selectedBoxes, box]);
                }
                return;
            }
        }
        setSelectedBox(box);
        setSearchGameName('');
        setSelectedGame(null);
        setStudioName('');
        
        // Initialize promotion states
        const isPromo = box.BoxType?.S === 'Promotion' || box.BoxType === 'Promotion';
        setIsPromotionBox(isPromo);
        
        let initialPromo = null;
        const promoID = box.PromotionID?.S || box.PromotionID;
        const promoText = box.DescriptiveText?.S || (typeof box.DescriptiveText === 'string' ? box.DescriptiveText : '');
        
        if (promoID) {
            initialPromo = brandPromotions.find(p => p.PromotionID === promoID) || null;
        } else if (promoText) {
            initialPromo = brandPromotions.find(p => p.Text.toLowerCase().trim() === promoText.toLowerCase().trim()) || null;
        }
        
        setSelectedPromo(initialPromo);
        setSearchPromoText(initialPromo ? initialPromo.Text : promoText);

        setSuggestions({ matches: [] });
        fetchSuggestions(box);
        setDialogOpen(true);
    };

    // --- Search Logic ---
    const handleSearch = (query) => {
        setSearchQuery(query);
        if (!query || !analysisResults) {
            setSearchResults([]);
            return;
        }

        const lowerQuery = query.toLowerCase();
        const results = analysisResults.filter(box => {
            const gameID = getSVal(box.ConfirmedMatch?.M || box, 'GameID') || '';
            const gameName = games.find(g => g.GameID === gameID)?.Name || '';
            const analysedName = getSVal(box.AnalysedText?.M || box, 'GameName') || '';
            const ocrName = getSVal(box, 'RecognizedText') || '';

            return (
                gameID.toLowerCase().includes(lowerQuery) ||
                gameName.toLowerCase().includes(lowerQuery) ||
                analysedName.toLowerCase().includes(lowerQuery) ||
                ocrName.toLowerCase().includes(lowerQuery)
            );
        });
        setSearchResults(results);
    };
    const handleTakeMeThere = () => {
        if (searchResults.length === 1) {
            setSearchDialogOpen(false);
            setNavigationMode('search');
            handleBoxClick(searchResults[0], true);
        }
    };

    const processAutoAdvance = (box) => {
        if (autoAdvance) {
            // Refresh analysis in background (silent) to update status without blocking
            const currentDataId = currentScreenshot.id?.S || currentScreenshot.id;
            fetchAnalysis(currentDataId, true);

            // Determine which list to navigate based on mode
            if (navigationMode === 'search') {
                if (searchResults.length > 0) {
                    const currentIndex = searchResults.findIndex(b => b.BoundingBoxID?.S === box.BoundingBoxID?.S);
                    const nextIndex = (currentIndex + 1) % searchResults.length;
                    handleBoxClick(searchResults[nextIndex]);
                } else {
                    setDialogOpen(false);
                }
            } else {
                // Default behavior: find next incomplete tile
                const sorted = getSortedUnconfirmedBoxes().filter(b => b.BoundingBoxID?.S !== box.BoundingBoxID?.S);
                if (sorted.length > 0) {
                    handleBoxClick(sorted[0]);
                } else {
                    setDialogOpen(false);
                }
            }
        } else {
            setDialogOpen(false);
        }
    };
    // --------------------

    const assignGame = async (box, game) => {
        // Optimistic UI update
        const boxId = box.BoundingBoxID?.S || box.BoundingBoxID;
        setAnalysisResults(prev => (prev || []).map(b => {
            const bId = b.BoundingBoxID?.S || b.BoundingBoxID;
            if (bId === boxId) {
                return {
                    ...b,
                    Status: { S: 'COMPLETE' },
                    stage: { S: 'ManualMatch' },
                    BoxType: { S: 'Game' },
                    ConfirmedMatch: {
                        M: {
                            GameID: { S: game.GameID },
                            Timestamp: { S: new Date().toISOString() }
                        }
                    }
                };
            }
            return b;
        }));
        
        // Save the original game ID for the anomaly list prompt
        const originalGameId = box.GameID?.S || box.GameID;
        if (originalGameId) {
            setLastOriginalGameId(originalGameId);
        }

        // Fire and forget the API calls in the background
        const performAssignment = async () => {
            try {
                // Update the Unconfirmed Analysis table
                await axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/set-unconfirmed-analysis`, {
                    WebsitesDataID: box.WebsitesDataID?.S || box.WebsitesDataID,
                    BoundingBoxID: box.BoundingBoxID?.S || box.BoundingBoxID,
                    GameID: game.GameID,
                    BoxType: 'Game',
                    Status: 'COMPLETE',
                    stage: 'ManualMatch',
                    RemoveAttributes: ['DescriptiveText', 'AssociatedGames', 'GroupName', 'ChildBoundingBoxIDs']
                }, {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                        'Content-Type': 'application/json',
                    },
                });

                if (promptAnomalyList && originalGameId) {
                    setAnomalyListModalOpen(true);
                }

                // Log the correction for the Smart Suggested list aggregation
                if (originalGameId && originalGameId !== game.GameID) {
                    try {
                        await axios.post(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/anomaly-review/corrections`, 
                            {
                                OriginalGameID: originalGameId,
                                CorrectedGameID: game.GameID,
                                Source: 'TimeMachine'
                            },
                            { headers: { 'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY } }
                        );
                    } catch (err) {
                        console.error('Failed to log correction in TimeMachine:', err);
                    }
                }

                // Prepare LLM match payload
                const llmMatchBody = {
                    DetectedText: box.AnalysedText?.M?.GameName?.S || game.Name,
                    GameID: game.GameID,
                    GameName: game.Name,
                    MatchType: 'Manual',
                    BoundingBoxID: box.BoundingBoxID?.S || box.BoundingBoxID,
                    WebsitesDataID: box.WebsitesDataID?.S || box.WebsitesDataID,
                };

                // Send LLM match update
                await axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/llm-text-match`, llmMatchBody, {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                        'Content-Type': 'application/json',
                    },
                });
            } catch (error) {
                console.error('❌ Error in background game assignment:', error);
            }
        };

        performAssignment(); // Start API calls in background
        processAutoAdvance(box); // Immediately move to next or close
    };

    const assignExistingPromotion = async (box, promo) => {
        if (!promo) return;
        const boxId = box.BoundingBoxID?.S || box.BoundingBoxID;

        // Compare and update LastSeenAt if the screenshot is more recent
        const scanTimestamp = currentScreenshot?.Timestamp?.S || currentScreenshot?.Timestamp;
        if (scanTimestamp) {
            const scanDateObj = new Date(scanTimestamp);
            const lastSeenObj = promo.LastSeenAt ? new Date(promo.LastSeenAt) : new Date(0);
            if (scanDateObj > lastSeenObj) {
                try {
                    await axios.put(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/promotions/${promo.PromotionID}`, {
                        LastSeenAt: scanDateObj.toISOString()
                    }, {
                        headers: {
                            'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY,
                            'Content-Type': 'application/json'
                        }
                    });
                    setBrandPromotions(prev => prev.map(p => 
                        p.PromotionID === promo.PromotionID 
                            ? { ...p, LastSeenAt: scanDateObj.toISOString() } 
                            : p
                    ));
                } catch (err) {
                    console.error("❌ Failed to update LastSeenAt on promotion:", err);
                }
            }
        }

        // Optimistic UI update
        setAnalysisResults(prev => (prev || []).map(b => {
            const bId = b.BoundingBoxID?.S || b.BoundingBoxID;
            if (bId === boxId) {
                return {
                    ...b,
                    BoxType: { S: 'Promotion' },
                    PromotionID: { S: promo.PromotionID },
                    AssociatedGames: { L: (promo.AssociatedGames || []).map(g => ({ S: g })) },
                    Status: { S: 'COMPLETE' },
                    stage: { S: 'ManualMatch' },
                };
            }
            return b;
        }));

        const performAssignment = async () => {
            try {
                await axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/set-unconfirmed-analysis`, {
                    WebsitesDataID: box.WebsitesDataID?.S || box.WebsitesDataID,
                    BoundingBoxID: box.BoundingBoxID?.S || box.BoundingBoxID,
                    BoxType: 'Promotion',
                    PromotionID: promo.PromotionID,
                    AssociatedGames: promo.AssociatedGames || [],
                    Status: 'COMPLETE',
                    stage: 'ManualMatch',
                    RemoveAttributes: [
                        'DescriptiveText', 'Tag', 'GameID', 'AnalysedText', 'DetectedText', 'LLMResponse', 
                        'RecognisedText', 'RecognizedText', 'ConfirmedMatch',
                        'RowPosition', 'ColumnPosition', 'FeaturedRank',
                        'SizeCategory', 'NearestRowNumber', 'DistanceToNearestRow'
                    ],
                    TriggerPositionAnalysis: true
                }, {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                        'Content-Type': 'application/json'
                    }
                });
            } catch (err) {
                console.error("❌ Error in background promotion assignment:", err);
            }
        };

        performAssignment();
        processAutoAdvance(box);
    };

    const handleCreateNewPromotion = async () => {
        try {
            if (!selectedBox) {
                console.warn("No tile selected for promotion creation.");
                return;
            }

            if (!newPromoText) {
                alert('Descriptive Text is required for Promotions.');
                return;
            }

            const scanTimestamp = currentScreenshot?.Timestamp?.S || currentScreenshot?.Timestamp;
            const response = await axios.post(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/promotions`, {
                BrandID: selectedWebsiteRecord?.BrandID || selectedWebsiteId,
                Text: newPromoText.trim(),
                Type: newPromoType || 'Promotion',
                AssociatedGames: newPromoAssociatedGames,
                LastSeenAt: scanTimestamp || undefined
            }, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY,
                    'Content-Type': 'application/json'
                }
            });

            if (response.data && response.data.Promotion) {
                const newPromo = response.data.Promotion;
                
                // Add to local catalog state
                setBrandPromotions(prev => [...prev, newPromo]);
                
                // Assign to bounding box
                await assignExistingPromotion(selectedBox, newPromo);

                // If newPromoType is a new tag, create it globally
                if (newPromoType && !promotionTypes.some(t => t.PromotionType.toLowerCase() === newPromoType.toLowerCase())) {
                    try {
                        const typeResponse = await axios.post(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/promotion-types`, {
                            PromotionType: newPromoType,
                            Description: 'Automatically created from Time Machine'
                        }, {
                            headers: {
                                'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY,
                                'Content-Type': 'application/json'
                            }
                        });
                        if (typeResponse.data && typeResponse.data.PromotionType) {
                            setPromotionTypes(prev => [...prev, typeResponse.data.PromotionType]);
                        }
                    } catch (err) {
                        console.error("Failed to create promotion type globally:", err);
                    }
                }
            }

            setNewPromoDialogOpen(false);
        } catch (error) {
            console.error('Error creating new promotion:', error);
        }
    };
    const handleSaveGameGroup = async () => {
        if (!groupName || !newGroupBox) return;

        try {
            const normalizedGroupName = groupName.toLowerCase().trim();
            const websitesDataId = currentScreenshot.id?.S || currentScreenshot.id;
            const websitesDbId = selectedWebsiteId;

            await axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/add-manual-unconfirmed-analysis`, {
                WebsitesDataID: websitesDataId,
                WebsitesDBID: websitesDbId,
                BoxType: 'GameGroup',
                GroupName: normalizedGroupName,
                ChildBoundingBoxIDs: newGroupBox.children,
                BoundingBox: {
                    Left: newGroupBox.left,
                    Top: newGroupBox.top,
                    Width: newGroupBox.width,
                    Height: newGroupBox.height
                },
                Status: 'COMPLETE'
            }, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                    'Content-Type': 'application/json'
                }
            });

            setGroupNameDialogOpen(false);
            setNewGroupBox(null);
            
            // Refresh analysis to show the new group box
            fetchAnalysis(websitesDataId, true);
            
            // Update local catalog cache for autocomplete immediately if possible
            const updatedCatalog = [...websiteCatalog];
            const siteIndex = updatedCatalog.findIndex(s => s.WebsitesDBID === websitesDbId);
            if (siteIndex !== -1) {
                const updatedSite = { ...updatedCatalog[siteIndex] };
                
                if (!updatedSite.KnownGroupNames) {
                    updatedSite.KnownGroupNames = [];
                }
                
                let names = updatedSite.KnownGroupNames;
                let changed = false;

                if (names.L) {
                    const currentNames = names.L.map(i => i.S);
                    if (!currentNames.includes(normalizedGroupName)) {
                        updatedSite.KnownGroupNames = {
                            ...names,
                            L: [...names.L, { S: normalizedGroupName }]
                        };
                        changed = true;
                    }
                } else if (Array.isArray(names)) {
                    if (!names.includes(normalizedGroupName)) {
                        updatedSite.KnownGroupNames = [...names, normalizedGroupName];
                        changed = true;
                    }
                }

                if (changed) {
                    updatedCatalog[siteIndex] = updatedSite;
                    setWebsiteCatalog(updatedCatalog);
                }
            }
            
        } catch (error) {
            console.error('Failed to save game group:', error);
            alert('Failed to save game group. Please try again.');
        }
    };

    const handleClonePreviousItems = async (itemTypeArg) => {
        const itemType = typeof itemTypeArg === 'string' ? itemTypeArg : drawBoxType; // 'GameGroup' or 'Promotion'
        const prevScan = screenshots[currentScreenshotIndex + 1];
        if (!prevScan) {
            alert(`No previous scan found to clone ${itemType === 'GameGroup' ? 'groups' : 'promotions'} from.`);
            return;
        }
        
        const prevScanId = prevScan.id?.S || prevScan.id;
        const currentScanId = currentScreenshot.id?.S || currentScreenshot.id;
        
        const typeLabel = itemType === 'GameGroup' ? 'game groups' : 'promotion boxes';
        const confirmMsg = itemType === 'GameGroup' 
            ? `Are you sure you want to clone game groups from ${moment(prevScan.timestamp?.S || prevScan.timestamp).format('LLL')}? This will recalculate the games currently inside those boxes.`
            : `Are you sure you want to clone promotion boxes from ${moment(prevScan.timestamp?.S || prevScan.timestamp).format('LLL')}?`;

        if (!window.confirm(confirmMsg)) return;

        setIsCloning(true);
        try {
            // Fetch previous analysis
            const response = await axios.get(`${process.env.REACT_APP_API_ANALYST_URL}/get-unconfirmed-analysis/${prevScanId}?cb=${Date.now()}`, {
                headers: { 'x-api-key': process.env.REACT_APP_API_ANALYST_KEY },
            });
            
            const prevResults = response.data || [];
            const prevItems = prevResults.filter(box => (box.BoxType?.S || box.BoxType) === itemType);
            
            if (prevItems.length === 0) {
                alert(`No ${typeLabel} found in the previous scan.`);
                setIsCloning(false);
                return;
            }
            
            let clonedCount = 0;
            // Create items sequentially
            for (const item of prevItems) {
                const bb = item.BoundingBox?.M || item.BoundingBox;
                
                const left = parseFloat(bb.Left?.N || bb.Left || 0);
                const top = parseFloat(bb.Top?.N || bb.Top || 0);
                const width = parseFloat(bb.Width?.N || bb.Width || 0);
                const height = parseFloat(bb.Height?.N || bb.Height || 0);
                
                let payload = {
                    WebsitesDataID: currentScanId,
                    WebsitesDBID: selectedWebsiteId,
                    BoxType: itemType,
                    BoundingBox: { Left: left, Top: top, Width: width, Height: height },
                    Status: itemType === 'Promotion' ? 'CONFIRMED' : 'COMPLETE',
                    stage: 'ManualMatch',
                    AnalysisTimestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSSSS'),
                    TriggerPositionAnalysis: true
                };

                if (itemType === 'GameGroup') {
                    const groupName = (item.GroupName?.S || item.GroupName || "").toLowerCase().trim();
                    // Recalculate children from CURRENT results
                    const children = (analysisResults || []).filter(box => {
                        const bType = getSVal(box, 'BoxType');
                        if (bType === 'GameGroup') return false;

                        const bLeft = getBBValue(box, 'Left');
                        const bTop = getBBValue(box, 'Top');
                        const bWidth = getBBValue(box, 'Width');
                        const bHeight = getBBValue(box, 'Height');
                        
                        const centerX = bLeft + bWidth / 2;
                        const centerY = bTop + bHeight / 2;
                        
                        return (centerX >= left && centerX <= left + width &&
                                centerY >= top && centerY <= top + height);
                    }).map(box => getSVal(box, 'BoundingBoxID') || box.BoundingBoxID);
                    
                    if (children.length === 0) {
                        console.log(`⚠️ Skipping GameGroup ${groupName} - no children found in destination.`);
                        continue;
                    }
                    payload.GroupName = groupName;
                    payload.ChildBoundingBoxIDs = children;
                } else {
                    // Promotion
                    const promotionID = getSVal(item, 'PromotionID');
                    const descriptiveText = getSVal(item, 'DescriptiveText');
                    const associatedGames = getLVal(item, 'AssociatedGames');
                    
                    if (promotionID) {
                        payload.PromotionID = promotionID;
                    } else if (descriptiveText) {
                        payload.DescriptiveText = descriptiveText;
                    }
                    if (associatedGames && associatedGames.length > 0) payload.AssociatedGames = associatedGames;
                }

                console.log(`📦 Cloning ${itemType} to ${currentScanId}:`, payload);
                const response = await axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/add-manual-unconfirmed-analysis`, payload, {
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                        'Content-Type': 'application/json'
                    }
                });
                console.log(`✅ ${itemType} cloned. Response:`, response.data);
                clonedCount++;
            }
            
            // Refresh current analysis
            await fetchAnalysis(currentScanId, true);
            alert(`Successfully cloned ${clonedCount} ${typeLabel}(s).`);
            
        } catch (err) {
            console.error(`Failed to clone ${itemType}s:`, err);
            alert(`Failed to clone ${typeLabel}.`);
        } finally {
            setIsCloning(false);
        }
    };

    const deleteBoundingBox = async (box) => {
        // Optimistic UI update
        const boxId = box.BoundingBoxID?.S || box.BoundingBoxID;
        setAnalysisResults(prev => (prev || []).filter(b => (b.BoundingBoxID?.S || b.BoundingBoxID) !== boxId));

        try {
            await axios.delete(`${process.env.REACT_APP_API_ANALYST_URL}/delete-unconfirmed-analysis`, {
                data: {
                    WebsitesDataID: currentScreenshot.id?.S || currentScreenshot.id,
                    BoundingBoxID: box.BoundingBoxID?.S || box.BoundingBoxID,
                },
                headers: {
                    'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                },
            });
            console.log('Bounding box deleted successfully');
        } catch (error) {
            console.error('Failed to delete bounding box:', error);
            throw error; // Propagate for batch handling
        }
    };

    const handleBatchDelete = async () => {
        if (!selectedBoxes.length) return;
        
        setLoadingScreenshots(true);
        try {
            // Execute all deletions in parallel
            await Promise.all(selectedBoxes.map(box => deleteBoundingBox(box)));
            
            // Refresh the analysis results
            const websitesDataId = currentScreenshot.id?.S || currentScreenshot.id;
            await fetchAnalysis(websitesDataId);
            
            setSelectedBoxes([]);
            setBatchDeleteMode(false);
            console.log('Batch deletion completed');
        } catch (error) {
            console.error('Batch deletion failed:', error);
            setError('Failed to delete some selected tiles. Please refresh and try again.');
        } finally {
            setLoadingScreenshots(false);
        }
    };

    const handleDeleteBox = async () => {
        if (!selectedBox) return;
        try {
            await deleteBoundingBox(selectedBox);
        } catch (error) {
            console.error('Failed to delete bounding box:', error);
        } finally {
            await processAutoAdvance(selectedBox);
        }
    };

    const handleCheckedToggle = async (event) => {
        const checked = event.target.checked;
        setIsChecked(checked); // Optimistic update

        if (!currentScreenshot) return;
        const screenshotId = currentScreenshot.id?.S || currentScreenshot.id;

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/screenshots/${screenshotId}/checked`, {
                checked: checked
            }, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY
                }
            });
            console.log('Checked status updated to:', checked);

            // Update local state to reflect change permanently in the screenshots array
            const updatedScreenshots = [...screenshots];
            if (updatedScreenshots[currentScreenshotIndex]) {
                updatedScreenshots[currentScreenshotIndex].Checked = checked;
            }
            setScreenshots(updatedScreenshots);

        } catch (error) {
            console.error('Error updating checked status:', error);
            setIsChecked(!checked); // Revert on error
            setError('Failed to update checked status');
        }
    };


    // Fetch website catalog with metadata and filters
    const fetchWebsiteCatalog = async () => {
        try {
            console.log('DEBUG: Fetching website catalog from:', `${process.env.REACT_APP_API_URL}/websites/catalog`);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/websites/catalog`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
            });

            console.log('DEBUG: Full API response object:', response);
            console.log('DEBUG: Response data type:', typeof response.data);
            console.log('DEBUG: Websites in response:', response.data?.websites);

            const catalog = Array.isArray(response.data?.websites) ? response.data.websites : [];
            const normalized = catalog
                .map((site) => ({
                    ...site,
                    WebsitesDBID: site.WebsitesDBID || site.id || site.WebsiteID || site.WebsiteId || '',
                    WebsiteName: site.WebsiteName || site.name || site.Name || 'Unnamed Website',
                }))
                .filter((site) => site.WebsitesDBID);

            console.log('DEBUG: Normalized catalog:', normalized);

            normalized.sort((a, b) => {
                const aTime = a.LastScanTimestamp ? new Date(a.LastScanTimestamp).getTime() : 0;
                const bTime = b.LastScanTimestamp ? new Date(b.LastScanTimestamp).getTime() : 0;
                return bTime - aTime;
            });

            setWebsiteCatalog(normalized);
            setCatalogFilters({
                countries: response.data?.filters?.countries || [],
                regions: response.data?.filters?.regions || [],
                brands: response.data?.filters?.brands || [],
                operators: response.data?.filters?.operators || [],
                tags: response.data?.filters?.tags || [],
            });
        } catch (err) {
            console.error('DEBUG: Error fetching website catalog:', err);
            setError('Error fetching website catalog.');
        }
    };

    // Set the Spinner status
    useEffect(() => {
        if (imageUrl) {
            setImageLoading(true);
        } else {
            // If imageUrl is manually cleared (e.g. for ERROR status), ensure loading is false
            setImageLoading(false);
        }
    }, [imageUrl]);



    // When the selected website changes, reset screenshots and related state
    const prevWebsiteIdRef = useRef(selectedWebsiteId);
    useEffect(() => {
        if (selectedWebsiteId && selectedWebsiteId !== prevWebsiteIdRef.current) {
            prevWebsiteIdRef.current = selectedWebsiteId;
            setScreenshots([]);
            setCurrentScreenshotIndex(0);
            setImageUrl('');
            setAnalysisResults(null);
        }
    }, [selectedWebsiteId]);

    // Handle deep links for scanId and date and fetch screenshots reactively
    useEffect(() => {
        if (!selectedWebsiteId || !isCatalogLoaded) {
            return;
        }

        if (urlScanId) {
            const currentId = currentScreenshot?.id?.S || currentScreenshot?.id;
            if (urlScanId !== currentId) {
                const matchedIndex = screenshots.findIndex(s => (s.id?.S || s.id) === urlScanId);
                if (matchedIndex !== -1) {
                    setCurrentScreenshotIndex(matchedIndex);
                    return;
                }
            }
        } else if (urlDate) {
            const targetDay = moment.utc(urlDate).format('YYYY-MM-DD');
            const currentDay = currentScreenshot?.Timestamp?.S || currentScreenshot?.Timestamp
                ? moment.utc(currentScreenshot.Timestamp?.S || currentScreenshot.Timestamp).format('YYYY-MM-DD')
                : null;
            if (targetDay !== currentDay) {
                let matchedIndex = screenshots.findIndex(s => {
                    const ts = s.Timestamp?.S || s.Timestamp;
                    return ts && moment.utc(ts).format('YYYY-MM-DD') === targetDay;
                });
                if (matchedIndex === -1 && screenshots.length > 0) {
                    const targetMoment = moment.utc(targetDay, 'YYYY-MM-DD');
                    let closestDiff = Infinity;
                    let bestIndex = 0;
                    screenshots.forEach((s, idx) => {
                        const ts = s.Timestamp?.S || s.Timestamp;
                        if (!ts) return;
                        const diff = Math.abs(moment.utc(ts).diff(targetMoment));
                        if (diff < closestDiff) {
                            closestDiff = diff;
                            bestIndex = idx;
                        }
                    });
                    matchedIndex = bestIndex;
                }
                if (matchedIndex !== -1 && matchedIndex !== currentScreenshotIndex) {
                    setCurrentScreenshotIndex(matchedIndex);
                    return;
                }
            }
        }

        if (screenshots.length === 0 && !loadingScreenshots) {
            const selectedSite = websiteCatalog.find((site) => site.WebsitesDBID === selectedWebsiteId);
            if (selectedSite) {
                if (urlScanId && !targetScanId) {
                    setTargetScanId(urlScanId);
                }
                fetchScreenshots(selectedWebsiteId, selectedSite.WebsiteName);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCatalogLoaded, urlScanId, urlDate, selectedWebsiteId, screenshots, loadingScreenshots]);

    // client/src/utils/screenshot.js
    const getSignedUrl = async (s3Url) => {
        if (!s3Url) return '';
        try {
            // Extract the key from the s3Url (standard project format is s3://bucket/key)
            const key = s3Url.replace('s3://', '').split('/').slice(1).join('/');

            const apiUrl = `${process.env.REACT_APP_API_URL}/screenshotssigned/${encodeURIComponent(key)}`;


            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
            });

            if (!response.ok) {
                console.error('Error response from signed URL API:', response.statusText);
                return '';
            }

            // Get the signed URL as plain text
            const signedUrl = await response.text();
            console.log('Received signed URL:', signedUrl);

            return signedUrl;
        } catch (error) {
            console.error('Error getting signed URL:', error);
            return '';
        }
    };

    const fetchPromotionTypes = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/promotion-types`, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY,
                },
            });
            if (response.data && response.data.promotionTypes) {
                setPromotionTypes(response.data.promotionTypes);
            }
        } catch (err) {
            console.error('Error fetching promotion types:', err);
        }
    };

    const fetchBrandPromotions = async (brandId) => {
        if (!brandId) return;
        setLoadingPromotions(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/promotions`, {
                params: { brandId },
                headers: {
                    'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY,
                },
            });
            if (response.data && response.data.promotions) {
                setBrandPromotions(response.data.promotions);
            }
        } catch (err) {
            console.error('Error fetching brand promotions:', err);
        } finally {
            setLoadingPromotions(false);
        }
    };

    useEffect(() => {
        if (selectedWebsiteId && selectedWebsiteRecord) {
            const brandId = selectedWebsiteRecord.BrandID || selectedWebsiteId;
            fetchBrandPromotions(brandId);
        } else {
            setBrandPromotions([]);
        }
    }, [selectedWebsiteId, selectedWebsiteRecord]);

    useEffect(() => {
        fetchPromotionTypes();
    }, []);

    useEffect(() => {
        if (selectedBox && isPromotionBox && brandPromotions.length > 0) {
            const promoID = selectedBox.PromotionID?.S || selectedBox.PromotionID;
            const promoText = selectedBox.DescriptiveText?.S || (typeof selectedBox.DescriptiveText === 'string' ? selectedBox.DescriptiveText : '');
            let match = null;
            if (promoID) {
                match = brandPromotions.find(p => p.PromotionID === promoID) || null;
            } else if (promoText) {
                match = brandPromotions.find(p => p.Text.toLowerCase().trim() === promoText.toLowerCase().trim()) || null;
            }
            if (match && !selectedPromo) {
                setSelectedPromo(match);
                setSearchPromoText(match.Text);
            }
        }
    }, [brandPromotions, selectedBox, isPromotionBox, selectedPromo]);

    useEffect(() => {
        let active = true;
        
        if (!selectedBox || !isPromotionBox || brandPromotions.length === 0) {
            setPromoSuggestions([]);
            setTranslatedOcrText('');
            return;
        }

        const ocrText = selectedBox.RecognisedText?.S || selectedBox.RecognizedText?.S || selectedBox.AnalysedText?.M?.GameName?.S || '';
        if (!ocrText) {
            setPromoSuggestions([]);
            setTranslatedOcrText('');
            return;
        }

        const performTranslationAndMatching = async () => {
            setIsTranslating(true);
            let translatedText = ocrText;
            try {
                const response = await fetch(
                    `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=en&dt=t&q=${encodeURIComponent(ocrText)}`
                );
                if (response.ok) {
                    const data = await response.json();
                    const resultText = data[0] ? data[0].map(segment => segment[0]).filter(Boolean).join('') : '';
                    if (resultText && active) {
                        translatedText = resultText;
                        setTranslatedOcrText(resultText);
                    }
                }
            } catch (error) {
                console.error('Error translating text for suggestion:', error);
            } finally {
                if (active) {
                    setIsTranslating(false);
                }
            }

            // Matching logic
            if (!active) return;

            const getSimilarity = (s1, s2) => {
                s1 = (s1 || '').toLowerCase().replace(/[^a-z0-9]/g, ' ').replace(/\s+/g, ' ').trim();
                s2 = (s2 || '').toLowerCase().replace(/[^a-z0-9]/g, ' ').replace(/\s+/g, ' ').trim();
                
                if (s1 === s2) return 100;
                if (!s1 || !s2) return 0;
                
                // Substring bonus
                if (s1.includes(s2) || s2.includes(s1)) {
                    return 90 + Math.round((Math.min(s1.length, s2.length) / Math.max(s1.length, s2.length)) * 10);
                }

                const getBigrams = (str) => {
                    const bigrams = new Set();
                    for (let i = 0; i < str.length - 1; i++) {
                        bigrams.add(str.substring(i, i + 2));
                    }
                    return bigrams;
                };

                const b1 = getBigrams(s1);
                const b2 = getBigrams(s2);

                let intersection = 0;
                for (const val of b1) {
                    if (b2.has(val)) {
                        intersection++;
                    }
                }

                if (b1.size + b2.size === 0) return 0;
                return Math.round((2 * intersection) / (b1.size + b2.size) * 100);
            };

            const suggestions = brandPromotions
                .map(promo => {
                    const similarityOriginal = getSimilarity(ocrText, promo.Text);
                    const similarityTranslated = getSimilarity(translatedText, promo.Text);
                    const maxSimilarity = Math.max(similarityOriginal, similarityTranslated);
                    
                    return {
                        ...promo,
                        Confidence: maxSimilarity
                    };
                })
                .filter(item => item.Confidence > 40)
                .sort((a, b) => b.Confidence - a.Confidence)
                .slice(0, 5);

            if (active) {
                setPromoSuggestions(suggestions);
            }
        };

        performTranslationAndMatching();

        return () => {
            active = false;
        };
    }, [selectedBox, isPromotionBox, brandPromotions]);



    const fetchScreenshots = async (websiteId, websiteNameFallback, startDate, endDate) => {
        setLoadingScreenshots(true);
        setError('');
        // Refresh catalog in the background to ensure we have latest KnownPromotions & metadata
        fetchWebsiteCatalog().catch(err => console.error('Failed to update website catalog:', err));
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/screenshots`, {
                params: {
                    websiteId,
                    websiteName: websiteNameFallback,
                    startDate: startDate || undefined,
                    endDate: endDate || undefined,
                },
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
            });
            const fetchedScreenshots = response.data || {};
            console.log('Fetched screenshots:', fetchedScreenshots);

            const screenshotsArray = fetchedScreenshots.screenshots || [];
            setScreenshots(screenshotsArray);

            let initialIndex = 0;
            if (targetScanId) {
                const matchedIndex = screenshotsArray.findIndex(s => (s.id?.S || s.id) === targetScanId);
                if (matchedIndex !== -1) {
                    initialIndex = matchedIndex;
                }
                setTargetScanId(null);
            } else if (urlDate) {
                const targetDay = moment.utc(urlDate).format('YYYY-MM-DD');
                let matchedIndex = screenshotsArray.findIndex(s => {
                    const ts = s.Timestamp?.S || s.Timestamp;
                    return ts && moment.utc(ts).format('YYYY-MM-DD') === targetDay;
                });
                if (matchedIndex === -1 && screenshotsArray.length > 0) {
                    const targetMoment = moment.utc(targetDay, 'YYYY-MM-DD');
                    let closestDiff = Infinity;
                    let bestIndex = 0;
                    screenshotsArray.forEach((s, idx) => {
                        const ts = s.Timestamp?.S || s.Timestamp;
                        if (!ts) return;
                        const diff = Math.abs(moment.utc(ts).diff(targetMoment));
                        if (diff < closestDiff) {
                            closestDiff = diff;
                            bestIndex = idx;
                        }
                    });
                    matchedIndex = bestIndex;
                }
                if (matchedIndex !== -1) {
                    initialIndex = matchedIndex;
                }
            }
            setCurrentScreenshotIndex(initialIndex);
        } catch (err) {
            console.error('Error fetching screenshots:', err);
            if (err.response?.status === 404) {
                setScreenshots([]);
                setCurrentScreenshotIndex(0);
                setImageUrl('');
                setAnalysisResults(null);
            }
            setError('Failed to load screenshots.');
        } finally {
            setLoadingScreenshots(false);
        }
    };

    const handleManualRefresh = async () => {
        if (!currentScreenshot) return;
        setIsRefreshing(true);
        // Refresh website catalog in parallel to manual analysis refresh
        fetchWebsiteCatalog().catch(err => console.error('Failed to refresh website catalog:', err));
        try {
            const screenshotId = currentScreenshot.id?.S || currentScreenshot.id;
            await fetchAnalysis(screenshotId, true); 
        } catch (err) {
            console.error('Manual refresh failed:', err);
        } finally {
            setIsRefreshing(false);
        }
    };

    // Global keyboard shortcuts for drawing, batch deleting, and refreshing
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            // Ignore shortcuts if user is typing in any input/textarea field
            const target = e.target;
            if (
                target.tagName === 'INPUT' ||
                target.tagName === 'TEXTAREA' ||
                target.isContentEditable
            ) {
                return;
            }

            const key = e.key.toLowerCase();
            if (key === 'g') {
                e.preventDefault();
                setDrawMode(prev => {
                    if (prev && drawBoxType === 'Game') {
                        return false;
                    }
                    setDrawBoxType('Game');
                    setBatchDeleteMode(false);
                    return true;
                });
            } else if (key === 'p') {
                e.preventDefault();
                setDrawMode(prev => {
                    if (prev && drawBoxType === 'Promotion') {
                        return false;
                    }
                    setDrawBoxType('Promotion');
                    setBatchDeleteMode(false);
                    return true;
                });
            } else if (key === 'o') {
                e.preventDefault();
                setDrawMode(prev => {
                    if (prev && drawBoxType === 'GameGroup') {
                        return false;
                    }
                    setDrawBoxType('GameGroup');
                    setBatchDeleteMode(false);
                    return true;
                });
            } else if (key === 'd') {
                e.preventDefault();
                setBatchDeleteMode(prev => {
                    if (!prev) {
                        setDrawMode(false);
                        setSelectedBoxes([]);
                    }
                    return !prev;
                });
            } else if (key === 'r') {
                e.preventDefault();
                handleManualRefresh();
            }
        };

        window.addEventListener('keydown', handleGlobalKeyDown);
        return () => window.removeEventListener('keydown', handleGlobalKeyDown);
    }, [drawBoxType, handleManualRefresh]);

    // Fetch analysis and signed URL when the screenshot changes
    useEffect(() => {
        if (screenshots.length > 0) {
            setError(''); // Clear any persistent error messages when moving to a new screenshot
            const currentScreenshot = screenshots[currentScreenshotIndex];
            if (currentScreenshot) {
                const screenshotId = currentScreenshot.id?.S || currentScreenshot.id;
                activeDataIdRef.current = screenshotId;
                console.log('Fetching analysis for websitesDataId:', screenshotId);
                fetchAnalysis(screenshotId);

                // Fetch signed URL for the current screenshot
                const imageLoc = currentScreenshot.ImageLocation?.S;
                if (imageLoc) {
                    fetchImageUrl(imageLoc);
                } else {
                    // Reset imageUrl and loading state if there's no location (e.g. ERROR status)
                    setImageUrl('');
                    setImageLoading(false);
                }

                // Reset image dimensions to prevent distorted crops while new image loads
                setImageDimensions({ width: 0, height: 0 });

                // Reset UI states for manual boxes and selections
                setNewGroupBox(null);
                setNewPromoBox(null);
                setSelectedBox(null);
                setSelectedBoxes([]);
                setGroupName('');
                setSelectedPromo(null);
                setSearchPromoText('');
                setIsPromotionBox(false);

                // Update checked status
                setIsChecked(currentScreenshot.Checked === true || currentScreenshot.Checked?.BOOL === true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentScreenshotIndex, screenshots[currentScreenshotIndex]?.id, screenshots[currentScreenshotIndex]?.ImageLocation]); // Only re-run if ID or ImageLocation changes


    const fetchAnalysis = async (websitesDataId, silent = false) => {
        if (!websitesDataId) return;

        if (!silent) {
            setAnalysisStatus('Loading Analysis');
            // Clear previous day's boxes immediately so they don't linger while new ones load
            if (activeDataIdRef.current === websitesDataId) {
                setAnalysisResults(null); 
            }
        }

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_ANALYST_URL}/get-unconfirmed-analysis/${websitesDataId}`,
                {
                    method: 'GET',
                    headers: {
                        'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                    },
                }
            );

            if (response.status === 404) {
                if (activeDataIdRef.current === websitesDataId) {
                    if (!silent) setAnalysisStatus('No Analysis Found');
                    setAnalysisResults(null);
                }
            } else {
                const resultData = await response.json();
                console.log('Analysis results:', resultData);
                // ONLY update if the user hasn't navigated away during the API call
                if (activeDataIdRef.current === websitesDataId) {
                    setAnalysisResults(resultData);
                    if (!silent) setAnalysisStatus('Loaded Analysis');
                }
                return resultData;
            }
        } catch (error) {
            console.error('Error fetching analysis results:', error);
            if (!silent) setAnalysisStatus('Error fetching analysis results');
        }

    };

    const fetchImageUrl = async (imageLocation) => {
        if (!imageLocation) return;
        const signedUrl = await getSignedUrl(imageLocation);
        setImageUrl(signedUrl);
    };


    const handleNextScreenshot = () => {
        const nextIndex = currentScreenshotIndex - 1;
        if (nextIndex >= 0) {
            setCurrentScreenshotIndex(nextIndex);
        }
    };

    const handlePreviousScreenshot = () => {
        const prevIndex = currentScreenshotIndex + 1;
        if (prevIndex < screenshots.length) {
            setCurrentScreenshotIndex(prevIndex);
        }
    };

    const handleWebsiteChange = (e) => {
        const nextWebsiteId = e.target.value;
        const currentDate = currentScreenshot?.Timestamp?.S || currentScreenshot?.Timestamp;
        const dateStr = currentDate ? moment.utc(currentDate).format('YYYY-MM-DD') : (searchParams.get('date') || '');

        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.set('websiteId', nextWebsiteId);
            newParams.delete('scanId'); // Clear scanId since scan IDs are specific to each site
            if (dateStr) {
                newParams.set('date', dateStr); // Retain active date across site changes!
            }
            return newParams;
        }, { replace: true });
    };

    const currentScreenshot = screenshots.length > 0 ? screenshots[currentScreenshotIndex] : null;

    const filteredWebsiteOptions = useMemo(() => {
        return websiteCatalog.filter((site) => {
            const country = site.Country || 'Unknown';
            const region = site.Region || 'Unknown';
            const matchesCountry = selectedCountryFilter === 'all' || country === selectedCountryFilter;
            const matchesRegion = selectedRegionFilter === 'all' || region === selectedRegionFilter;
            const matchesTag = selectedTagFilter === 'all' || (site.Tags && site.Tags.includes(selectedTagFilter));
            const matchesActive = !showActiveOnly || site.Active;
            return matchesCountry && matchesRegion && matchesTag && matchesActive;
        });
    }, [websiteCatalog, selectedCountryFilter, selectedRegionFilter, selectedTagFilter, showActiveOnly]);

    const groupedWebsiteOptions = useMemo(() => {
        const groups = {};
        filteredWebsiteOptions.forEach((site) => {
            const brand = site.BrandName || 'Other Websites';
            if (!groups[brand]) groups[brand] = [];
            groups[brand].push(site);
        });
        return Object.entries(groups).sort(([a], [b]) => a.localeCompare(b));
    }, [filteredWebsiteOptions]);

    const countryOptions = useMemo(() => {
        const base = new Set(['all', ...(catalogFilters.countries || []).filter(Boolean)]);
        const hasUnknown = websiteCatalog.some((site) => !site.Country);
        if (hasUnknown) {
            base.add('Unknown');
        }
        return Array.from(base);
    }, [catalogFilters.countries, websiteCatalog]);

    const regionOptions = useMemo(() => {
        const base = new Set(['all', ...(catalogFilters.regions || []).filter(Boolean)]);
        const hasUnknown = websiteCatalog.some((site) => !site.Region);
        if (hasUnknown) {
            base.add('Unknown');
        }
        return Array.from(base);
    }, [catalogFilters.regions, websiteCatalog]);

    useEffect(() => {
        if (!isCatalogLoaded) return;
        if (!filteredWebsiteOptions.length) {
            if (selectedWebsiteId && !targetScanId) {
                setSearchParams(prev => {
                    const newParams = new URLSearchParams(prev);
                    newParams.delete('websiteId');
                    newParams.delete('scanId');
                    newParams.delete('date');
                    return newParams;
                }, { replace: true });
            }
            return;
        }
        const exists = filteredWebsiteOptions.some((site) => site.WebsitesDBID === selectedWebsiteId);
        if (!selectedWebsiteId || !exists) {
            if (!targetScanId) {
                setSearchParams(prev => {
                    const newParams = new URLSearchParams(prev);
                    newParams.set('websiteId', filteredWebsiteOptions[0].WebsitesDBID);
                    newParams.delete('scanId');
                    return newParams;
                }, { replace: true });
            }
        }
    }, [filteredWebsiteOptions, selectedWebsiteId, isCatalogLoaded, targetScanId, setSearchParams]);

    // Continuously sync active state bounds seamlessly (No page refresh jumps)
    useEffect(() => {
        const current = screenshots[currentScreenshotIndex];
        const currentId = current ? (current.id?.S || current.id) : null;
        const currentTimestamp = current ? (current.Timestamp?.S || current.Timestamp) : null;
        const currentDateStr = currentTimestamp ? moment.utc(currentTimestamp).format('YYYY-MM-DD') : null;
        
        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            let updated = false;

            if (currentId && newParams.get('scanId') !== currentId) {
                newParams.set('scanId', currentId);
                updated = true;
            }

            if (currentDateStr && newParams.get('date') !== currentDateStr) {
                newParams.set('date', currentDateStr);
                updated = true;
            }

            if (selectedCountryFilter !== 'all') {
                if (newParams.get('country') !== selectedCountryFilter) {
                    newParams.set('country', selectedCountryFilter);
                    updated = true;
                }
            } else if (newParams.has('country')) {
                newParams.delete('country');
                updated = true;
            }

            if (selectedRegionFilter !== 'all') {
                if (newParams.get('region') !== selectedRegionFilter) {
                    newParams.set('region', selectedRegionFilter);
                    updated = true;
                }
            } else if (newParams.has('region')) {
                newParams.delete('region');
                updated = true;
            }

            return updated ? newParams : prev;
        }, { replace: true });
    }, [currentScreenshotIndex, screenshots, selectedCountryFilter, selectedRegionFilter, setSearchParams]);

    // Logging the state for debugging
    useEffect(() => {
        console.log('DEBUG: Website catalog count:', websiteCatalog.length);
        console.log('DEBUG: Filtered Website Options count:', filteredWebsiteOptions.length);
        console.log('DEBUG: Selected Website ID:', selectedWebsiteId);
        if (websiteCatalog.length > 0) {
            console.log('DEBUG: Sample Website (first item):', websiteCatalog[0]);
        }
        console.log('DEBUG: Current Screenshot Index:', currentScreenshotIndex);
        console.log('DEBUG: Current Screenshot:', currentScreenshot);
        console.log('DEBUG: Image URL:', imageUrl ? 'URL Present' : 'URL Missing');
        console.log('DEBUG: Analysis Status:', analysisStatus);
    }, [
        websiteCatalog,
        filteredWebsiteOptions,
        selectedWebsiteId,
        screenshots,
        currentScreenshotIndex,
        currentScreenshot,
        imageUrl,
        analysisResults,
        analysisStatus,
    ]);


    // Handle mouse events for drawing bounding boxes
    const handleMouseDown = (e) => {
        if (!drawMode) return;
        e.preventDefault(); // Prevent image dragging/highlighting
        const rect = e.currentTarget.getBoundingClientRect();
        setStartCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top });
        setCurrentCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top });
        setIsDragging(true);
    };

    const handleMouseMove = (e) => {
        if (!drawMode || !isDragging) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setCurrentCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top });
    };

    const handleMouseUp = (e) => {
        if (!drawMode || !isDragging) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const endCoords = { x: e.clientX - rect.left, y: e.clientY - rect.top };

        const pixelWidth = Math.abs(startCoords.x - endCoords.x);
        const pixelHeight = Math.abs(startCoords.y - endCoords.y);

        setIsDragging(false);

        if (pixelWidth < 5 || pixelHeight < 5) {
            console.log('⚠️ Ignoring too-small box.');
            setStartCoords(null);
            setCurrentCoords(null);
            return;
        }

        const left = Math.min(startCoords.x, endCoords.x) / rect.width;
        const top = Math.min(startCoords.y, endCoords.y) / rect.height;
        const width = pixelWidth / rect.width;
        const height = pixelHeight / rect.height;

        handleDrawBox(left, top, width, height);

        setStartCoords(null);
        setCurrentCoords(null);
    };



    const handleDrawBox = async (left, top, width, height) => {
        // Handle Game Group drawing
        if (drawBoxType === 'GameGroup') {
            // Find child tiles that intersect with this group box
            const children = (analysisResults || []).filter(box => {
                const bType = getSVal(box, 'BoxType');
                if (bType === 'GameGroup') return false; // Don't nest groups for now

                const bLeft = getBBValue(box, 'Left');
                const bTop = getBBValue(box, 'Top');
                const bWidth = getBBValue(box, 'Width');
                const bHeight = getBBValue(box, 'Height');
                
                // Use center point for assignment logic (most reliable for tiles)
                const centerX = bLeft + bWidth / 2;
                const centerY = bTop + bHeight / 2;
                
                return (centerX >= left && centerX <= left + width &&
                        centerY >= top && centerY <= top + height);
            }).map(box => getSVal(box, 'BoundingBoxID') || box.BoundingBoxID);

            setNewGroupBox({ left, top, width, height, children });
            setGroupName('');
            setGroupNameDialogOpen(true);
            // We keep drawMode as true so it's a toggle
            return;
        }

        // Handle Promotion drawing - now merged into general flow but with auto-open
        if (drawBoxType === 'Promotion') {
            setSelectedPromo(null);
            setSearchPromoText('');
        }

        try {
            if (drawBoxType === 'Promotion') {
                setIsCreatingBox(true);
            }
            console.log(`📦 Creating manual bounding box (${drawBoxType}) with:`, {
                Left: left,
                Top: top,
                Width: width,
                Height: height
            });

            const websitesDataId = currentScreenshot.id?.S || currentScreenshot.id;

            await axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/add-manual-unconfirmed-analysis`, {
                WebsitesDataID: websitesDataId,
                BoxType: drawBoxType,
                BoundingBox: {
                    Left: left,
                    Top: top,
                    Width: width,
                    Height: height
                },
                Status: drawBoxType === 'Promotion' ? 'CONFIRMED' : 'INCOMPLETE'
            }, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                    'Content-Type': 'application/json'
                }
            });

            console.log('✅ Bounding box created successfully.');

            // Immediate regular refresh to show the new box
            let updatedAnalysis = await fetchAnalysis(websitesDataId);

            // If it's a promotion, open the dialog automatically
            if (drawBoxType === 'Promotion') {
                let newBox = updatedAnalysis?.find(b => {
                    const bb = b.BoundingBox?.M || b.BoundingBox;
                    if (!bb) return false;
                    const bLeft = parseFloat(bb.Left?.N ?? bb.Left);
                    const bTop = parseFloat(bb.Top?.N ?? bb.Top);
                    return Math.abs(bLeft - left) < 0.02 && Math.abs(bTop - top) < 0.02;
                });

                // If not found (eventual consistency), wait a bit and try one more time
                if (!newBox) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                    updatedAnalysis = await fetchAnalysis(websitesDataId, true);
                    newBox = updatedAnalysis?.find(b => {
                        const bb = b.BoundingBox?.M || b.BoundingBox;
                        if (!bb) return false;
                        const bLeft = parseFloat(bb.Left?.N ?? bb.Left);
                        const bTop = parseFloat(bb.Top?.N ?? bb.Top);
                        return Math.abs(bLeft - left) < 0.02 && Math.abs(bTop - top) < 0.02;
                    });
                }

                if (newBox) {
                    setDrawMode(false); 
                    setTimeout(() => {
                        handleBoxClick(newBox);
                    }, 100); // 100ms to be absolutely sure
                }
            }


            // Schedule silent refreshes to update details as backend processes
            // Backend logs show execution times around 8-13 seconds.
            setTimeout(() => {
                console.log('🔄 Running 5s silent refresh...');
                fetchAnalysis(websitesDataId, true);
            }, 5000);

            setTimeout(() => {
                console.log('🔄 Running 10s silent refresh...');
                fetchAnalysis(websitesDataId, true);
            }, 10000);

            setTimeout(() => {
                console.log('🔄 Running 15s silent refresh...');
                fetchAnalysis(websitesDataId, true);
            }, 15000);

        } catch (error) {
            console.error('❌ Failed to create bounding box:', error.response?.data || error.message);
        } finally {
            setIsCreatingBox(false);
        }
    };





    const SUGGESTION_STOP_WORDS = new Set([
        'the', 'a', 'an', 'of', 'in', 'on', 'and', 'at', 'to', 'for', 'with', 'by', 'from', 'or', 'is', 'it', 'as',
        'slot', 'slots', 'game', 'games', 'deluxe', 'live', 'edition', 'respin', 'respins', 'spin', 'spins',
        'play', 'new'
    ]);

    const isPlaceholderText = (text) => {
        if (!text || typeof text !== 'string') return true;
        const clean = text.trim().toUpperCase();
        return [
            'NO TEXT DETECTED',
            'NO MATCH',
            'UNKNOWN',
            'UNASSIGNED TILE',
            'UNKNOWN GAME',
            'NO NAME DETECTED',
            'GAME UNKNOWN',
            'NULL',
            'NONE',
            'N/A'
        ].includes(clean);
    };

    const getQueryTextFromBox = (box) => {
        if (!box) return '';
        // 1. Raw OCR text (American, British, or DetectedText)
        const ocrCandidate = getSVal(box, 'RecognizedText') || getSVal(box, 'RecognisedText') || getSVal(box, 'DetectedText');
        if (ocrCandidate && !isPlaceholderText(ocrCandidate)) {
            return ocrCandidate.trim();
        }
        // 2. AnalysedText GameName
        const analysedName = getSVal(box.AnalysedText?.M || box, 'GameName');
        if (analysedName && !isPlaceholderText(analysedName)) {
            return analysedName.trim();
        }
        // 3. Fallback to ConfirmedMatch Game name if reassigning
        const confirmedGameId = getSVal(box.ConfirmedMatch?.M || box, 'GameID');
        if (confirmedGameId && games) {
            const matched = games.find(g => g.GameID === confirmedGameId);
            if (matched?.Name && !isPlaceholderText(matched.Name)) {
                return matched.Name.trim();
            }
        }
        return '';
    };

    const getSignificantTokens = (str) => {
        return (str || '')
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, ' ')
            .split(/\s+/)
            .filter(t => t.length >= 2 && !SUGGESTION_STOP_WORDS.has(t));
    };

    const getBigrams = (str) => {
        const s = (str || '').replace(/\s+/g, '');
        const bg = new Set();
        for (let i = 0; i < s.length - 1; i++) {
            bg.add(s.substring(i, i + 2));
        }
        return bg;
    };

    const diceCoefficient = (b1, b2) => {
        if (b1.size + b2.size === 0) return 0;
        let inter = 0;
        for (const v of b1) {
            if (b2.has(v)) inter++;
        }
        return (2 * inter) / (b1.size + b2.size);
    };

    const findGameSuggestions = (query, allGames, allStudios) => {
        if (!query || isPlaceholderText(query) || !allGames || allGames.length === 0) return [];

        const normQuery = query.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
        if (!normQuery) return [];

        const queryTokens = getSignificantTokens(normQuery);
        const queryBigrams = getBigrams(normQuery);

        const scored = [];

        for (let i = 0; i < allGames.length; i++) {
            const game = allGames[i];
            if (!game || !game.Name) continue;
            const normName = game.Name.toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
            if (!normName) continue;

            let score = 0;

            // 1. Exact match
            if (normName === normQuery) {
                score = 100;
            } 
            // 2. Direct Substring Match
            else if (normName.includes(normQuery) || normQuery.includes(normName)) {
                const ratio = Math.min(normName.length, normQuery.length) / Math.max(normName.length, normQuery.length);
                score = 75 + Math.round(ratio * 24);
            } else {
                const gameTokens = getSignificantTokens(normName);
                const gameBigrams = getBigrams(normName);

                // 3. Token Overlap (handles jumbled word order and noise)
                let overlapCount = 0;
                for (const qt of queryTokens) {
                    if (gameTokens.includes(qt)) {
                        overlapCount += 1;
                    } else if (gameTokens.some(gt => gt.startsWith(qt) || qt.startsWith(gt))) {
                        overlapCount += 0.7;
                    }
                }

                if (overlapCount > 0 && queryTokens.length > 0) {
                    const queryCoverage = overlapCount / queryTokens.length;
                    const gameCoverage = overlapCount / gameTokens.length;
                    const union = queryTokens.length + gameTokens.length - overlapCount;
                    const jaccard = overlapCount / (union > 0 ? union : 1);

                    score = Math.round(queryCoverage * 40 + gameCoverage * 35 + jaccard * 25);
                }

                // 4. Character Bigram Similarity (handles typos, character swaps)
                const dice = diceCoefficient(queryBigrams, gameBigrams);
                const diceScore = Math.round(dice * 100);
                if (diceScore > score) {
                    score = Math.max(score, diceScore);
                }
            }

            if (score >= 45) {
                const studio = allStudios && allStudios.find(s => s.StudioID === game.StudioID);
                scored.push({
                    GameID: game.GameID,
                    Name: game.Name,
                    StudioID: game.StudioID || 'unknown',
                    StudioName: studio?.Name || 'Unknown',
                    Confidence: score
                });
            }
        }

        scored.sort((a, b) => b.Confidence - a.Confidence);
        return scored.slice(0, 6);
    };

    const fetchSuggestions = async (box) => {
        if (!box) {
            setSuggestions({ matches: [] });
            return;
        }

        const gameNameQuery = getQueryTextFromBox(box);
        const boxId = getSVal(box, 'BoundingBoxID') || box.BoundingBoxID?.S || box.BoundingBoxID || 'box';

        if (!gameNameQuery) {
            setSuggestions({ matches: [] });
            setLoadingSuggestions(false);
            return;
        }

        // 1. Instant local matching using cached games/studios
        if (games && games.length > 0) {
            const localMatches = findGameSuggestions(gameNameQuery, games, studios);
            if (localMatches.length > 0) {
                setSuggestions({ matches: localMatches });
                setLoadingSuggestions(false);
                return;
            }
        }

        // 2. Fallback to remote API if no local matches or cache not yet populated
        setLoadingSuggestions(true);
        try {
            const requestPayload = {
                requests: [{
                    BoundingBoxID: boxId,
                    GameName: gameNameQuery
                }]
            };

            const response = await axios.post(`${process.env.REACT_APP_API_GAMES_STUDIOS_URL}/name-suggestions`, requestPayload, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_GAMES_STUDIOS_KEY
                }
            });

            if (response.data && response.data.suggestions && response.data.suggestions[boxId]) {
                setSuggestions({ matches: response.data.suggestions[boxId] });
            } else {
                setSuggestions({ matches: [] });
            }

        } catch (err) {
            console.error("Error fetching name suggestions for box:", err);
            setSuggestions({ matches: [] });
        } finally {
            setLoadingSuggestions(false);
        }
    };

    const handleAssignSuggestion = async (suggestion) => {
        if (!selectedBox) return;

        try {
            await assignGame(selectedBox, { GameID: suggestion.GameID, Name: suggestion.Name });

            const llmMatchBody = {
                DetectedText: getSVal(selectedBox, 'RecognizedText') || getSVal(selectedBox, 'RecognisedText') || getSVal(selectedBox.AnalysedText?.M || selectedBox, 'GameName'),
                GameID: suggestion.GameID,
                GameName: suggestion.Name,
                MatchType: "Suggestion",
                BoundingBoxID: getSVal(selectedBox, 'BoundingBoxID') || selectedBox.BoundingBoxID,
                WebsitesDataID: getSVal(selectedBox, 'WebsitesDataID') || selectedBox.WebsitesDataID
            };

            void axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/llm-text-match`, llmMatchBody, {
                headers: {
                    'x-api-key': process.env.REACT_APP_API_ANALYST_KEY,
                    'Content-Type': 'application/json'
                }
            }).catch(err =>
                console.error("LLM match logging failed", err.response?.data || err.message)
            );

            // Dialog closing/advance is now handled by assignGame

        } catch (error) {
            console.error('Failed to assign suggestion:', error);
        }
    };

    const handleGameCreated = async (newGameData) => {
        try {
            if (!selectedBox) return;
            await assignGame(selectedBox, { GameID: newGameData.GameID, Name: newGameData.Name });
        } catch (error) {
            console.error('Error assigning game after creation:', error);
        }
    };

    const renderTileTooltipContent = (box) => {
        const isPromotion = getSVal(box, 'BoxType') === 'Promotion';
        const status = getSVal(box, 'Status');
        const isComplete = status === 'COMPLETE' || status === 'PROMOTION';
        const gameID = getSVal(box, 'GameID') || getSVal(box.ConfirmedMatch?.M || box, 'GameID');
        const game = games.find((g) => g.GameID === gameID);
        const studio = game ? studios.find((s) => s.StudioID === game.StudioID) : null;

        return (
            <>
                <strong>{isPromotion ? '🎁 Promotion' : (isComplete ? '✅ Completed Analysis' : '🕵️ Awaiting Match')}</strong>
                <br />
                {isPromotion && (
                    <>
                        <strong>Text:</strong> {brandPromotions.find(p => p.PromotionID === getSVal(box, 'PromotionID'))?.Text || getSVal(box, 'DescriptiveText') || 'No description'}
                        <br />
                        {box.AssociatedGames && (
                            <>
                                <strong>Games:</strong> {(box.AssociatedGames?.L ? box.AssociatedGames.L.map(i => i.S) : (Array.isArray(box.AssociatedGames) ? box.AssociatedGames : []))
                                    .map(id => games.find(g => g.GameID === id)?.Name || id)
                                    .join(', ')}
                                <br />
                            </>
                        )}
                        <br />
                    </>
                )}

                <strong>Stage:</strong> {getSVal(box, 'stage') || 'Unknown'}
                <br />
                <strong>Match Source:</strong> {getSVal(box, 'MatchSource') || 'Unknown'}
                <br />
                <strong>Confidence:</strong> {(parseFloat(box.MatchConfidence?.N || box.MatchConfidence) || 0).toFixed(2)}
                <br />

                {isComplete ? (
                    <>
                        <strong>Game Name:</strong> {game ? game.Name : 'Unknown'}
                        <br />
                        <br />
                        <CopyToClipboardText label="Game ID" text={gameID} />
                        <br />
                        <strong>Studio:</strong> {studio ? studio.Name : 'Unknown'}
                        <br />
                        <strong>Completed At:</strong> {moment.utc(getSVal(box.ConfirmedMatch?.M || box, 'Timestamp')).format('MMMM Do YYYY, HH:mm:ss') + ' UTC' || 'Unknown'}
                    </>
                ) : (
                    <>
                        <strong>Recognised Text:</strong> {getSVal(box, 'RecognisedText') || getSVal(box, 'RecognizedText') || 'Unknown'}
                        <br />
                        <strong>Detected Text:</strong> {getSVal(box, 'DetectedText') || 'Unknown'}
                        <br />
                        <strong>Analysis - Game Name:</strong> {getSVal(box.AnalysedText?.M || box, 'GameName') || 'N/A'}
                        <br />

                    </>
                )}
            </>
        );
    };






    if (!isCatalogLoaded) {
        return (
            <Flex
                height="80vh"
                width="100%"
                alignItems="center"
                justifyContent="center"
                direction="column"
                gap="1rem"
            >
                <CircularProgress />
                <Heading level={3}>Initializing Time Machine...</Heading>
                <Text>Fetching catalog and historical data...</Text>
            </Flex>
        );
    }

    return (
        <View margin="2rem" position="relative">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Heading level={2}>Time Machine</Heading>
                <IconButton 
                    onClick={() => setWhatsNewOpen(true)} 
                    size="small" 
                    color="primary"
                    sx={{ ml: 1, border: 1, borderColor: 'primary.light', p: 0.5 }}
                    title="What's New Guide"
                >
                    <HelpIcon fontSize="small" />
                </IconButton>
            </Box>

            <Flex gap="1rem" flexWrap="wrap" marginTop="1rem" alignItems="flex-end">
                <SelectField
                    label="Country Filter"
                    value={selectedCountryFilter}
                    onChange={(e) => setSelectedCountryFilter(e.target.value)}
                >
                    {countryOptions.map((option) => (
                        <option key={option} value={option}>
                            {option === 'all' ? 'All Countries' : option}
                        </option>
                    ))}
                </SelectField>

                <SelectField
                    label="Region Filter"
                    value={selectedRegionFilter}
                    onChange={(e) => setSelectedRegionFilter(e.target.value)}
                >
                    {regionOptions.map((option) => (
                        <option key={option} value={option}>
                            {option === 'all' ? 'All Regions' : option}
                        </option>
                    ))}
                </SelectField>

                <SelectField
                    label="Tag Filter"
                    value={selectedTagFilter}
                    onChange={(e) => setSelectedTagFilter(e.target.value)}
                >
                    <option value="all">All Tags</option>
                    {(catalogFilters.tags || []).map((tag) => (
                        <option key={tag} value={tag}>
                            {tag}
                        </option>
                    ))}
                </SelectField>

                <FormControlLabel
                    control={
                        <Switch
                            checked={showActiveOnly}
                            onChange={(e) => setShowActiveOnly(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Active (last 30 days)"
                />
                <Text fontSize="0.85rem" color="#555">
                    Showing {filteredWebsiteOptions.length} of {websiteCatalog.length} websites
                </Text>
            </Flex>

            <SelectField
                label="Select Website"
                value={selectedWebsiteId || ''}
                onChange={handleWebsiteChange}
                disabled={!filteredWebsiteOptions.length}
            >
                <option value="" disabled>
                    {filteredWebsiteOptions.length ? 'Select a website' : 'No websites available'}
                </option>
                {groupedWebsiteOptions.map(([brandName, sites]) => (
                    <optgroup key={brandName} label={brandName}>
                        {sites.map((site) => {
                            const locationParts = [site.Country, site.Region].filter(Boolean).join(' • ');
                            const lastScanLabel = site.LastScanTimestamp
                                ? moment.utc(site.LastScanTimestamp).fromNow()
                                : 'no scans yet';
                            return (
                                <option key={site.WebsitesDBID} value={site.WebsitesDBID}>
                                    {site.WebsiteName}
                                    {locationParts ? ` (${locationParts})` : ''} • {lastScanLabel}
                                </option>
                            );
                        })}
                    </optgroup>
                ))}
            </SelectField>

            {selectedWebsiteRecord && (
                <Text backgroundColor="#f5f5f5" padding="0.5rem" marginTop="0.5rem">
                    Last scan:{' '}
                    {selectedWebsiteRecord.LastScanTimestamp
                        ? moment.utc(selectedWebsiteRecord.LastScanTimestamp).format('MMMM Do YYYY, HH:mm:ss') + ' UTC'
                        : 'No scans yet'}
                    {' · '}
                    Status: {selectedWebsiteRecord.Active ? 'Active' : 'Dormant'}
                </Text>
            )}

            <Text backgroundColor="lightgray" padding="0.5rem" marginTop="1rem">
                {analysisStatus}
            </Text>

            {error && <Alert variation="error">{error}</Alert>}

            <Flex direction="column" justifyContent="center" alignItems="center" style={{ marginBottom: '1rem' }}>
                <Flex justifyContent="center" alignItems="center" gap="1rem">
                    <Button
                        variant="text"
                        onClick={handlePreviousScreenshot}
                        disabled={currentScreenshotIndex >= screenshots.length - 1}
                    >
                        ◀ Older
                    </Button>
                    {currentScreenshot && (
                        <Flex direction="column" alignItems="center">
                            <TextField
                                type="date"
                                size="small"
                                value={moment.utc(currentScreenshot.Timestamp?.S || currentScreenshot.Timestamp).format('YYYY-MM-DD')}
                                onChange={(e) => {
                                    const pickedDate = e.target.value;
                                    if (!pickedDate) return;
                                    const targetMoment = moment.utc(pickedDate, 'YYYY-MM-DD');
                                    let bestIndex = 0;
                                    let minDiff = Infinity;
                                    screenshots.forEach((s, idx) => {
                                        const ts = s.Timestamp?.S || s.Timestamp;
                                        if (!ts) return;
                                        const diff = Math.abs(moment.utc(ts).diff(targetMoment));
                                        if (diff < minDiff) {
                                            minDiff = diff;
                                            bestIndex = idx;
                                        }
                                    });
                                    setCurrentScreenshotIndex(bestIndex);
                                }}
                                inputProps={{
                                    style: { padding: '4px 8px', fontSize: '0.85rem', textAlign: 'center', cursor: 'pointer' }
                                }}
                                sx={{ bgcolor: '#fff', borderRadius: 1 }}
                            />
                            <Typography variant="caption" color="textSecondary" sx={{ mt: 0.25 }}>
                                {moment.utc(currentScreenshot.Timestamp?.S || currentScreenshot.Timestamp).format('HH:mm:ss')} UTC
                            </Typography>
                        </Flex>
                    )}
                    <Button
                        variant="text"
                        onClick={handleNextScreenshot}
                        disabled={currentScreenshotIndex <= 0}
                    >
                        Newer ▶
                    </Button>
                </Flex>

                {currentScreenshot && (
                    <Flex direction="row" alignItems="center" justifyContent="center">
                        <CopyToClipboardText label="WebsitesDataID" text={currentScreenshot.id?.S || currentScreenshot.id} />
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isChecked}
                                    onChange={handleCheckedToggle}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label="Checked"
                            sx={{ marginLeft: '1rem', marginTop: '0.5rem' }}
                        />
                    </Flex>
                )}
            </Flex>


            <Flex justifyContent="center" alignItems="center">
                <Button
                    variant="contained"
                    onClick={() => setShowPositions(!showPositions)}
                    style={{ marginTop: '1rem', marginBottom: '1rem' }}
                    sx={{ margin: '0.5rem' }}
                >
                    {showPositions ? 'Hide Page Position Analysis' : 'Show Page Position Analysis'}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setSearchQuery('');
                        setSearchResults([]);
                        setSearchDialogOpen(true);
                    }}
                    style={{ margin: '0.5rem' }}
                    startIcon={<SearchIcon />}
                >
                    Search
                </Button>

                {batchDeleteMode && selectedBoxes.length > 0 && (
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleBatchDelete}
                        style={{ margin: '0.5rem', backgroundColor: '#d32f2f' }}
                    >
                        Delete {selectedBoxes.length} Selected
                    </Button>
                )}

                {currentScreenshot && (
                    <>
                        <input
                            type="file"
                            accept="image/*"
                            id="manual-replace-input"
                            style={{ display: 'none' }}
                            onChange={(e) => handleManualUpload(e.target.files[0])}
                        />
                        <label htmlFor="manual-replace-input">
                            <Button
                                variant="contained"
                                component="span"
                                color="secondary"
                                disabled={uploadingManual}
                                style={{ margin: '0.5rem' }}
                                startIcon={<CloudUploadIcon />}
                            >
                                {uploadingManual ? 'Replacing...' : 'Replace Screenshot'}
                            </Button>
                        </label>
                    </>
                )}
            </Flex>



            {
                currentScreenshot ? (
                    // Screenshot View
                    <View
                        style={{
                            position: 'relative',
                            cursor: drawMode ? 'crosshair' : 'default',
                            userSelect: drawMode ? 'none' : 'auto',
                            WebkitUserSelect: drawMode ? 'none' : 'auto',
                            MozUserSelect: drawMode ? 'none' : 'auto',
                            msUserSelect: drawMode ? 'none' : 'auto'
                        }}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        position="relative">
                        {/* Render the main screenshot */}

                        <>
                            { (imageLoading || uploadingManual || isCreatingBox) && (
                                <Box
                                    sx={{
                                        position: isCreatingBox ? 'fixed' : 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 9999,
                                        backgroundColor: 'rgba(0, 0, 0, 0.65)',
                                        padding: 3,
                                        borderRadius: '12px',
                                        textAlign: 'center',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 1.5,
                                        minWidth: 220,
                                    }}
                                >
                                    <CircularProgress sx={{ color: '#fff' }} />
                                    <Typography variant="body1" sx={{ color: '#fff', fontWeight: 500 }}>
                                        {uploadingManual ? 'Uploading Screenshot...' : isCreatingBox ? 'Extracting Promo Text...' : 'Loading Image...'}
                                    </Typography>
                                </Box>
                            )}

                            { (currentScreenshot.ScreenshotStatus?.S === 'ERROR' || currentScreenshot.ScreenshotStatus === 'ERROR') ? (
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: '400px',
                                        backgroundColor: '#f5f5f5',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '2px dashed #ccc',
                                        borderRadius: '8px',
                                        p: 3
                                    }}
                                >
                                    <Typography variant="h6" color="error" gutterBottom>
                                        Screenshot Capture Failed
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" sx={{ mb: 3, textAlign: 'center' }}>
                                        {currentScreenshot.ErrorMessage?.S || currentScreenshot.ErrorMessage || 'No specific error message was returned.'}
                                    </Typography>
                                    
                                    <input
                                        type="file"
                                        accept="image/*"
                                        id="manual-upload-input"
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleManualUpload(e.target.files[0])}
                                    />
                                    <label htmlFor="manual-upload-input">
                                        <Button
                                            variant="contained"
                                            component="span"
                                            color="primary"
                                            disabled={uploadingManual}
                                            startIcon={<CloudUploadIcon />}
                                        >
                                            {uploadingManual ? 'Replacing...' : 'Replace Screenshot'}
                                        </Button>

                                    </label>
                                </Box>
                            ) : (
                                <Box sx={{ position: 'relative' }}>
                                    <img
                                        src={imageUrl}
                                        alt="Screenshot"
                                        crossOrigin="anonymous"
                                        draggable="false"
                                        onLoad={(e) => {
                                            setImageLoading(false);
                                            setImageDimensions({ width: e.target.naturalWidth, height: e.target.naturalHeight });
                                        }}
                                        onError={() => setImageLoading(false)}
                                        style={{
                                            width: '100%',
                                            pointerEvents: 'none',
                                            display: imageLoading ? 'none' : 'block',
                                        }}
                                    />
                                    
                                    {/* Small floating button to allow re-upload if needed? Oh, maybe later. 
                                        Let's at least show status if it's PENDING_MANUAL. 
                                    */}
                                    { (currentScreenshot.ScreenshotStatus?.S === 'PENDING_MANUAL' || currentScreenshot.ScreenshotStatus === 'PENDING_MANUAL') && (
                                        <MuiAlert 
                                            severity="info" 
                                            sx={{ 
                                                position: 'absolute', 
                                                top: 10, 
                                                right: 10, 
                                                zIndex: 10,
                                                opacity: 0.9
                                            }}
                                        >
                                            Manual Upload: Pending overnight analysis
                                        </MuiAlert>
                                    )}

                                </Box>
                            )}
                        </>





                        {drawMode && isDragging && startCoords && currentCoords && (
                            <div
                                style={{
                                    position: 'absolute',
                                    border: '2px dashed yellow',
                                    left: `${Math.min(startCoords.x, currentCoords.x)}px`,
                                    top: `${Math.min(startCoords.y, currentCoords.y)}px`,
                                    width: `${Math.abs(startCoords.x - currentCoords.x)}px`,
                                    height: `${Math.abs(startCoords.y - currentCoords.y)}px`,
                                    pointerEvents: 'none',
                                    zIndex: 10
                                }}
                            />
                        )}
                        {/* Render bounding boxes */}
                        {analysisResults &&
                            analysisResults.length > 0 &&
                            analysisResults
                                .filter(box => {
                                    const isGroup = getSVal(box, 'BoxType') === 'GameGroup';
                                    if (isGroup && !(drawMode && drawBoxType === 'GameGroup')) {
                                        return false;
                                    }
                                    return true;
                                })
                                .map((box, index) => (
                                <Tooltip
                                    key={index}
                                    title={(drawMode && drawBoxType === 'GameGroup') ? "" : renderTileTooltipContent(box)} // Disable rollovers in GameGroup mode
                                    arrow
                                    placement="top"
                                    slotProps={{
                                        tooltip: {
                                            sx: {
                                                maxWidth: 500, // Make the tooltip wider for better readability
                                            },
                                        },
                                    }}
                                >
                                    <View
                                        onMouseDown={(e) => e.stopPropagation()} // Prevent starting a new box when clicking existing one
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent propagation to parent handlers
                                            const isGroupClick = drawMode && drawBoxType === 'GameGroup' && getSVal(box, 'BoxType') === 'GameGroup';
                                            if (drawMode && !isGroupClick) return; 
                                            setNavigationMode('unconfirmed');
                                            handleBoxClick(box);
                                        }}
                                        style={{ 
                                            position: 'absolute',
                                            left: `${getBBValue(box, 'Left') * 100}%`,
                                            top: `${getBBValue(box, 'Top') * 100}%`,
                                            width: `${getBBValue(box, 'Width') * 100}%`,
                                            height: `${getBBValue(box, 'Height') * 100}%`,
                                            cursor: 'pointer',
                                            borderStyle: 'solid',
                                            borderWidth: batchDeleteMode && selectedBoxes.some(b => (b.BoundingBoxID?.S || b.BoundingBoxID) === (box.BoundingBoxID?.S || box.BoundingBoxID)) ? '8px' : '5px',
                                            borderColor: batchDeleteMode && selectedBoxes.some(b => (b.BoundingBoxID?.S || b.BoundingBoxID) === (box.BoundingBoxID?.S || box.BoundingBoxID))
                                                ? '#2196f3' 
                                                : (getSVal(box, 'BoxType') === 'GameGroup')
                                                    ? '#ffeb3b' 
                                                    : (getSVal(box, 'BoxType') === 'Promotion')
                                                        ? '#9c27b0' 
                                                    : (getSVal(box, 'Status') === 'COMPLETE') 
                                                        ? (getSVal(box, 'stage') === 'ManualMatch' ? 'orange' : 'green') 
                                                        : 'red',
                                            backgroundColor: batchDeleteMode && selectedBoxes.some(b => (b.BoundingBoxID?.S || b.BoundingBoxID) === (box.BoundingBoxID?.S || box.BoundingBoxID))
                                                ? 'rgba(33, 150, 243, 0.4)' 
                                                : 'transparent',
                                            zIndex: getSVal(box, 'BoxType') === 'GameGroup' ? 20 : 10
                                        }}
                                    >
                                        {/* Game Group Label */}
                                        {(getSVal(box, 'BoxType') === 'GameGroup') && (
                                            <Text
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '5px',
                                                    right: '5px',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    color: 'black',
                                                    backgroundColor: 'rgba(255, 235, 59, 0.9)',
                                                    padding: '2px 4px',
                                                    borderRadius: '3px',
                                                    pointerEvents: 'none'
                                                }}
                                            >
                                                {getSVal(box, 'GroupName') || 'Unnamed Group'}
                                            </Text>
                                        )}
                                        {/* Keep the checkmark icon for completed status */}
                                        {getSVal(box, 'Status') === 'COMPLETE' && (
                                            <CheckCircleIcon
                                                sx={{
                                                    position: 'absolute',
                                                    top: 8,
                                                    right: 8,
                                                    color: getSVal(box, 'stage') === 'ManualMatch' ? 'orange' : 'green',
                                                }}
                                            />
                                        )}

                                        {/* Add row/column position text when showPositions is true */}
                                        {showPositions && (
                                            <Text
                                                style={{
                                                    position: 'absolute',
                                                    top: '5px',
                                                    left: '5px',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    color: 'white',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                                    padding: '2px 4px',
                                                    borderRadius: '3px',
                                                }}
                                            >
                                                {parseFloat(box.RowPosition?.N) === 0 && parseFloat(box.ColumnPosition?.N) === 0
                                                    ? 'Feature Spot'
                                                    : `R${parseFloat(box.RowPosition?.N) || 'N/A'} - C${parseFloat(box.ColumnPosition?.N) || 'N/A'}`}                                    </Text>
                                        )}
                                    </View>
                                </Tooltip>
                            ))}
                    </View>

                ) : (
                    <Text>{loadingScreenshots ? 'Loading screenshots...' : 'No screenshots available'}</Text>
                )
            }

            <Dialog disableScrollLock open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box display="flex" alignItems="center">
                        Assign / Reassign Bounding Box
                    </Box>
                    <Box display="flex" alignItems="center">
                        <IconButton onClick={handlePreviousUnconfirmed} size="small" title="Previous Unconfirmed">
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="body2" sx={{ mx: 1 }}>
                            {navigationMode === 'search'
                                ? `${searchResults.findIndex(b => b.BoundingBoxID?.S === selectedBox?.BoundingBoxID?.S) + 1} / ${searchResults.length}`
                                : `${getSortedUnconfirmedBoxes().findIndex(b => b.BoundingBoxID?.S === selectedBox?.BoundingBoxID?.S) + 1} / ${getSortedUnconfirmedBoxes().length}`
                            }
                        </Typography>
                        <IconButton onClick={handleNextUnconfirmed} size="small" title="Next Unconfirmed">
                            <ArrowForwardIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {selectedBox && (
                        <>
                            {getSVal(selectedBox, 'BoxType') === 'GameGroup' ? (
                                <Box>
                                    <Box sx={{ bgcolor: '#fffde7', p: 2, borderRadius: 2, mb: 3, border: '1px solid #fbc02d' }}>
                                        <Typography variant="caption" color="textSecondary" display="block">
                                            GAME GROUP DETAILS
                                        </Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#f57f17', mb: 1 }}>
                                            {getSVal(selectedBox, 'GroupName') || 'Unnamed Group'}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            This group spatially encompasses <strong>{getLVal(selectedBox, 'ChildBoundingBoxIDs').length}</strong> identified tiles.
                                        </Typography>
                                    </Box>

                                    <Typography variant="subtitle2" gutterBottom>Edit Group Name</Typography>
                                    <Box display="flex" gap={2} mb={4}>
                                        <Autocomplete
                                            freeSolo
                                            fullWidth
                                            options={(() => {
                                                const site = websiteCatalog.find(s => s.WebsitesDBID === selectedWebsiteId);
                                                if (!site || !site.KnownGroupNames) return [];
                                                if (Array.isArray(site.KnownGroupNames)) return site.KnownGroupNames;
                                                if (site.KnownGroupNames.L) return site.KnownGroupNames.L.map(i => i.S);
                                                if (site.KnownGroupNames.SS) return site.KnownGroupNames.SS;
                                                return [];
                                            })()}
                                            value={groupName}
                                            onInputChange={(e, val) => setGroupName(val ? val.toLowerCase() : '')}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Update Group Name" variant="outlined" />
                                            )}
                                        />
                                        <Button 
                                            variant="contained" 
                                            onClick={async () => {
                                                try {
                                                    await axios.post(`${process.env.REACT_APP_API_ANALYST_URL}/add-manual-unconfirmed-analysis`, {
                                                        WebsitesDataID: getSVal(selectedBox, 'WebsitesDataID'),
                                                        WebsitesDBID: selectedWebsiteId,
                                                        BoxType: 'GameGroup',
                                                        GroupName: groupName.toLowerCase().trim(),
                                                        BoundingBoxID: getSVal(selectedBox, 'BoundingBoxID'), // This will trigger an overwrite/update in the backend
                                                        ChildBoundingBoxIDs: getLVal(selectedBox, 'ChildBoundingBoxIDs'),
                                                        BoundingBox: {
                                                            Left: getBBValue(selectedBox, 'Left'),
                                                            Top: getBBValue(selectedBox, 'Top'),
                                                            Width: getBBValue(selectedBox, 'Width'),
                                                            Height: getBBValue(selectedBox, 'Height')
                                                        }
                                                    }, {
                                                        headers: { 'x-api-key': process.env.REACT_APP_API_ANALYST_KEY }
                                                    });
                                                    fetchAnalysis(getSVal(selectedBox, 'WebsitesDataID'), true);
                                                    console.log('Group name updated');
                                                } catch (err) {
                                                    console.error('Failed to update group name:', err);
                                                }
                                            }}
                                        >
                                            Update
                                        </Button>
                                        <Button 
                                            variant="outlined" 
                                            color="error"
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={async () => {
                                                if (window.confirm('Are you sure you want to delete this game group?')) {
                                                    try {
                                                        await deleteBoundingBox(selectedBox);
                                                        setDialogOpen(false);
                                                        fetchAnalysis(getSVal(selectedBox, 'WebsitesDataID'), true);
                                                    } catch (err) {
                                                        console.error('Failed to delete group:', err);
                                                    }
                                                }
                                            }}
                                        >
                                            Delete Group
                                        </Button>
                                    </Box>

                                    <Typography variant="subtitle2" gutterBottom>Contained Games</Typography>
                                    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 300 }}>
                                        <Table size="small" stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Box ID</TableCell>
                                                    <TableCell>Game Name</TableCell>
                                                    <TableCell>Game ID</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {getLVal(selectedBox, 'ChildBoundingBoxIDs').map(childId => {
                                                    const childBox = (analysisResults || []).find(b => (getSVal(b, 'BoundingBoxID') || b.BoundingBoxID) === childId);
                                                    const gameId = getSVal(childBox?.ConfirmedMatch?.M || childBox, 'GameID');
                                                    const gameName = games.find(g => g.GameID === gameId)?.Name || getSVal(childBox?.AnalysedText?.M || childBox, 'GameName') || 'Unknown';
                                                    
                                                    return (
                                                        <TableRow key={childId} hover>
                                                            <TableCell sx={{ fontSize: '0.75rem', fontFamily: 'monospace' }}>{childId.split('-box-')[1] || childId}</TableCell>
                                                            <TableCell sx={{ fontWeight: gameId ? 'bold' : 'normal' }}>{gameName}</TableCell>
                                                            <TableCell sx={{ fontSize: '0.75rem', color: 'textSecondary' }}>{gameId || 'Unassigned'}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            ) : (
                                <>
                            <Box 
                                display="flex" 
                                flexDirection={getBBValue(selectedBox, 'Width') > 0.4 ? 'column' : 'row'}
                                justifyContent="space-between" 
                                alignItems={getBBValue(selectedBox, 'Width') > 0.4 ? 'stretch' : 'flex-start'} 
                                mb={2}
                                gap={3}
                            >
                                {/* Left Side / Top Side: Metadata */}
                                <Box flex={1}>
                                    {/* Show common metadata */}
                                    <Box sx={{ bgcolor: '#f5f5f5', p: 1.5, borderRadius: 2, mb: 2 }}>
                                        <Typography variant="caption" color="textSecondary" display="block">
                                            METADATA
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Bounding Box ID:</strong> {getSVal(selectedBox, 'BoundingBoxID') || 'Unknown'}
                                            <br />
                                            <strong>WebsitesData ID:</strong> {getSVal(selectedBox, 'WebsitesDataID') || 'Unknown'}
                                        </Typography>
                                    </Box>

                                    {isPromotionBox ? (
                                        <Box>
                                            <Typography variant="caption" color="textSecondary" display="block">
                                                ASSIGNED PROMOTION
                                            </Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#9c27b0', mb: 0.5 }}>
                                                {brandPromotions.find((p) => p.PromotionID === getSVal(selectedBox, 'PromotionID'))?.Text || getSVal(selectedBox, 'DescriptiveText') || 'Unassigned Promotion'}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {getSVal(selectedBox, 'PromotionID') && (
                                                    <>
                                                        <CopyToClipboardText
                                                            label="Promo ID"
                                                            text={getSVal(selectedBox, 'PromotionID')}
                                                            variant="body2"
                                                        />
                                                        <br />
                                                    </>
                                                )}
                                                <strong>Brand:</strong> {selectedWebsiteRecord?.BrandName || selectedWebsiteRecord?.WebsiteName || 'Unknown Brand'}
                                                <br />
                                                <strong>Recognized Text:</strong> {getSVal(selectedBox, 'RecognizedText') || getSVal(selectedBox, 'RecognisedText') || 'No recognized text'}
                                                <br />
                                                {isTranslating ? (
                                                    <Typography variant="caption" sx={{ fontStyle: 'italic', display: 'block', color: 'text.secondary', pl: 1 }}>
                                                        Translating to English...
                                                    </Typography>
                                                ) : translatedOcrText && translatedOcrText.toLowerCase().trim() !== (getSVal(selectedBox, 'RecognizedText') || getSVal(selectedBox, 'RecognisedText') || '').toLowerCase().trim() ? (
                                                    <>
                                                        <strong>Translated (EN):</strong> {translatedOcrText}
                                                        <br />
                                                    </>
                                                ) : null}
                                                {getSVal(selectedBox, 'Timestamp') && moment(getSVal(selectedBox, 'Timestamp')).isValid() && (
                                                    <>
                                                        <strong>Completed At:</strong> {moment(getSVal(selectedBox, 'Timestamp')).format('MMMM Do YYYY, h:mm:ss a')}
                                                        <br />
                                                    </>
                                                )}
                                            </Typography>
                                        </Box>
                                    ) : getSVal(selectedBox, 'Status') === 'COMPLETE' ? (
                                        <Box>
                                            <Typography variant="caption" color="textSecondary" display="block">
                                                ASSIGNED GAME
                                            </Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 0.5 }}>
                                                {games.find((g) => g.GameID === getSVal(selectedBox.ConfirmedMatch?.M || selectedBox, 'GameID'))?.Name || 'Unknown'}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                <strong>Studio:</strong> {
                                                    studios.find((s) =>
                                                        s.StudioID === games.find((g) =>
                                                            g.GameID === getSVal(selectedBox.ConfirmedMatch?.M || selectedBox, 'GameID'))?.StudioID
                                                    )?.Name || 'Unknown'
                                                }
                                                <br />
                                                <strong>Game ID:</strong> {getSVal(selectedBox.ConfirmedMatch?.M || selectedBox, 'GameID') || 'Unknown'}
                                                <br />
                                                <strong>Completed At:</strong> {moment(getSVal(selectedBox.ConfirmedMatch?.M || selectedBox, 'Timestamp')).format('MMMM Do YYYY, h:mm:ss a') || 'Unknown'}
                                            </Typography>
                                        </Box>
                                    ) : (
                                        <Box>
                                            <Typography variant="caption" color="textSecondary" display="block">
                                                AI PREDICTION
                                            </Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
                                                {getSVal(selectedBox.AnalysedText?.M || selectedBox, 'GameName') || 'Unassigned Tile'}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                <strong>Recognized Text:</strong> {getSVal(selectedBox, 'RecognizedText') || getSVal(selectedBox, 'RecognisedText') || 'No recognized text'}
                                                <br />
                                                <strong>Confidence:</strong> {(parseFloat(selectedBox.Confidence?.N || selectedBox.Confidence) || 0).toFixed(2)}%
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>

                                {/* Right Side / Bottom Side: Image Crop */}
                                {imageUrl && imageDimensions.width > 0 && (
                                    <Box
                                        sx={{
                                            width: getBBValue(selectedBox, 'Width') > 0.4 ? '100%' : '270px',
                                            aspectRatio: `${(getBBValue(selectedBox, 'Width') * imageDimensions.width) / (getBBValue(selectedBox, 'Height') * imageDimensions.height)}`,
                                            maxHeight: '250px', 
                                            minHeight: '100px',
                                            overflow: 'hidden',
                                            position: 'relative',
                                            border: '3px solid #ff1744',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                            flexShrink: 0,
                                            alignSelf: 'center',
                                            bgcolor: '#000' // Dark background for gaps
                                        }}
                                    >
                                        <img
                                            src={imageUrl}
                                            alt="Tile Crop"
                                            style={{
                                                position: 'absolute',
                                                top: `-${(getBBValue(selectedBox, 'Top') / getBBValue(selectedBox, 'Height')) * 100}%`,
                                                left: `-${(getBBValue(selectedBox, 'Left') / getBBValue(selectedBox, 'Width')) * 100}%`,
                                                width: `${(1 / getBBValue(selectedBox, 'Width')) * 100}%`,
                                                height: `${(1 / getBBValue(selectedBox, 'Height')) * 100}%`,
                                                maxWidth: 'none',
                                                display: 'block'
                                            }}
                                        />
                                    </Box>
                                )}
                            </Box>

                            <Divider sx={{ marginY: 2 }}>Classification</Divider>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isPromotionBox}
                                        onChange={(e) => setIsPromotionBox(e.target.checked)}
                                        color="secondary"
                                    />
                                }
                                label="Promotion Tile"
                                sx={{ mb: 2 }}
                            />

                                          {isPromotionBox ? (
                                <Box sx={{ mt: 2 }}>
                                    <Box display="flex" gap={2} alignItems="flex-start" mb={3}>
                                        <Box flexGrow={1}>
                                            <Autocomplete
                                                fullWidth
                                                options={brandPromotions}
                                                getOptionLabel={(option) => option.Text || ''}
                                                value={selectedPromo}
                                                onChange={(event, newValue) => {
                                                    setSelectedPromo(newValue);
                                                    setSearchPromoText(newValue ? newValue.Text : '');
                                                }}
                                                inputValue={searchPromoText}
                                                onInputChange={(event, newInputValue, reason) => {
                                                    if (reason === 'input' || reason === 'clear') {
                                                        setSearchPromoText(newInputValue);
                                                        const matchedPromo = brandPromotions.find(p => p.Text === newInputValue);
                                                        setSelectedPromo(matchedPromo || null);
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        autoFocus
                                                        label="Search Existing Master Promotion"
                                                        variant="outlined"
                                                        placeholder="Type to search..."
                                                    />
                                                )}
                                            />
                                        </Box>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={!selectedPromo}
                                            sx={{ height: '56px' }}
                                            onClick={async () => {
                                                try {
                                                    await assignExistingPromotion(selectedBox, selectedPromo);
                                                } catch (error) {
                                                    console.error('Failed to assign promotion:', error);
                                                }
                                            }}
                                        >
                                            Assign Selected
                                        </Button>
                                    </Box>

                                    {/* 💡 Fuzzy Promotion Suggestions */}
                                    {(() => {
                                        const ocrText = selectedBox.RecognisedText?.S || selectedBox.RecognizedText?.S || selectedBox.AnalysedText?.M?.GameName?.S || '';
                                        return ocrText && promoSuggestions.length > 0 && (
                                            <Box sx={{ mb: 3, p: 2, border: '1px solid #ffd54f', borderRadius: 2, bgcolor: '#fffde7' }}>
                                                <Typography variant="caption" color="textSecondary" display="block" sx={{ mb: 1, fontWeight: 'bold', color: '#f57f17' }}>
                                                    💡 SUGGESTED PROMOTIONS (Fuzzy matched from OCR: "{ocrText}")
                                                </Typography>
                                                <Grid container spacing={1}>
                                                    {promoSuggestions.map((suggestion, idx) => (
                                                        <Grid item xs={12} key={idx}>
                                                            <Box sx={{ 
                                                                display: 'flex', 
                                                                alignItems: 'center', 
                                                                justifyContent: 'space-between', 
                                                                p: 1, 
                                                                borderRadius: 1, 
                                                                border: '1px solid #ffe082',
                                                                bgcolor: '#fff',
                                                                '&:hover': { bgcolor: '#fff8e1' }
                                                            }}>
                                                                <Box sx={{ mr: 1, minWidth: 0, flex: 1 }}>
                                                                    <Typography variant="body2" sx={{ fontWeight: 600, noWrap: true, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                        {suggestion.Text}
                                                                    </Typography>
                                                                    <Typography variant="caption" color="textSecondary">
                                                                        Tag: {suggestion.Type} | Confidence: {suggestion.Confidence}%
                                                                    </Typography>
                                                                </Box>
                                                                <Button 
                                                                    size="small" 
                                                                    variant="outlined" 
                                                                    color="warning"
                                                                    onClick={() => {
                                                                        const matched = brandPromotions.find(p => p.PromotionID === suggestion.PromotionID);
                                                                        if (matched) {
                                                                            setSelectedPromo(matched);
                                                                            setSearchPromoText(matched.Text);
                                                                            assignExistingPromotion(selectedBox, matched).catch(error => {
                                                                                console.error('Failed to assign promotion:', error);
                                                                            });
                                                                        }
                                                                    }}
                                                                    sx={{ ml: 1, py: 0.2 }}
                                                                >
                                                                    Use
                                                                </Button>
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Box>
                                        );
                                    })()}

                                    <Divider sx={{ marginY: 2 }}>OR</Divider>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                            setNewPromoText(searchPromoText || (selectedBox.RecognisedText?.S || selectedBox.RecognizedText?.S || selectedBox.AnalysedText?.M?.GameName?.S || ''));
                                            setNewPromoType('Promotion');
                                            setNewPromoAssociatedGames([]);
                                            setNewPromoDialogOpen(true);
                                        }}
                                        fullWidth
                                        style={{ marginTop: '0.5rem' }}
                                    >
                                        Create New Master Promotion
                                    </Button>
                                </Box>
                            ) : (
                                <>
                                    <Divider sx={{ marginY: 2 }}>Possible Matches</Divider>
                                    {loadingSuggestions ? (
                                        <Box display="flex" justifyContent="center" padding={2}>
                                            <CircularProgress size={24} />
                                        </Box>
                                    ) : suggestions && suggestions.matches && suggestions.matches.length > 0 ? (
                                        <Grid container spacing={2}>
                                            {suggestions.matches.map((suggestion, index) => (
                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                    <Box sx={{ marginBottom: 1, border: '1px solid #eee', padding: 1, borderRadius: 1, height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Box>
                                                            <Typography variant="body2" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>{suggestion.Name}</Typography>
                                                            <Typography variant="caption" display="block" color="textSecondary" sx={{ mb: 0.5 }}>{suggestion.StudioName || 'Unknown'}</Typography>
                                                            <Typography variant="caption" display="block" color="textSecondary">Conf: {suggestion.Confidence ? suggestion.Confidence.toFixed(2) : 'N/A'}%</Typography>
                                                        </Box>
                                                        <Button
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={() => handleAssignSuggestion(suggestion)}
                                                            sx={{ marginLeft: 1, minWidth: 'auto' }}
                                                        >
                                                            Assign
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary">No suggestions found.</Typography>
                                    )}

                                    <Divider sx={{ marginY: 2 }}>Manual Search</Divider>

                                    <Box display="flex" gap={2} alignItems="flex-start">
                                        <Box flexGrow={1}>
                                            {/* Editable Game selection */}
                                            <Autocomplete
                                                freeSolo
                                                fullWidth
                                                options={uniqueGameNames} // array of strings
                                                value={searchGameName}    // current input
                                                onChange={(event, newValue) => {
                                                    if (newValue) {
                                                        const matchedGame = games.find(game => game.Name === newValue);
                                                        if (matchedGame) {
                                                            setSelectedGame(matchedGame);
                                                            setSearchGameName(newValue);
                                                            setStudioName(studios.find(s => s.StudioID === matchedGame.StudioID)?.Name || '');
                                                            // Explicit selection via enter/click on the dropdown
                                                            assignGame(selectedBox, matchedGame);
                                                        }
                                                    }
                                                }}
                                                onInputChange={(event, newInputValue, reason) => {
                                                    if (reason === 'input' || reason === 'clear') {
                                                        setSearchGameName(newInputValue); // updates as user types
                                                        const matchedGame = games.find(game => game.Name === newInputValue);
                                                        setSelectedGame(matchedGame || null);
                                                        setStudioName(
                                                            matchedGame ? studios.find(s => s.StudioID === matchedGame.StudioID)?.Name : ''
                                                        );
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        autoFocus
                                                        label="Search or Assign Game"
                                                        variant="outlined"
                                                        fullWidth
                                                        onKeyDown={(e) => {
                                                            // e.defaultPrevented is true when MUI Autocomplete uses Enter to select from the dropdown
                                                            if (e.key === 'Enter' && !e.defaultPrevented && selectedGame) {
                                                                assignGame(selectedBox, selectedGame);
                                                            }
                                                        }}
                                                    />
                                                )}
                                            />
                                            {/* Studio display */}
                                            <Typography variant="subtitle2" style={{ marginTop: '0.5rem' }}>
                                                Studio: {studioName || 'Unknown'}
                                            </Typography>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={promptAnomalyList}
                                                        onChange={(e) => setPromptAnomalyList(e.target.checked)}
                                                        size="small"
                                                    />
                                                }
                                                label="Flag original game to Anomaly List"
                                                sx={{ mt: 1, display: 'block' }}
                                            />
                                        </Box>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={!selectedGame}
                                            sx={{ height: '56px' }} // Match default helpful height of text fields
                                            onClick={async () => {
                                                try {
                                                    await assignGame(selectedBox, selectedGame);
                                                    // fetchAnalysis is now handled inside assignGame
                                                } catch (error) {
                                                    console.error('Failed to assign game:', error);
                                                }
                                            }}
                                        >
                                            Assign / Reassign
                                        </Button>
                                    </Box>

                                    <Divider sx={{ marginY: 2 }}>OR</Divider>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={() => {
                                            setNewGameName(searchGameName);
                                            setNewGameDialogOpen(true);
                                        }}
                                        fullWidth
                                        style={{ marginTop: '0.5rem' }}
                                    >
                                        Create New Game
                                    </Button>
                                    
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        onClick={() => setAnomalyListModalOpen(true)}
                                        fullWidth
                                        style={{ marginTop: '0.5rem' }}
                                        disabled={!selectedGame}
                                    >
                                        Flag to Anomaly List
                                    </Button>
                                </>
                            )}
                        </>
                    )}
                </>
            )}
                </DialogContent>
                <DialogActions>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={autoAdvance}
                                onChange={(e) => setAutoAdvance(e.target.checked)}
                                size="small"
                            />
                        }
                        label="Auto-advance"
                        sx={{ marginRight: 'auto', marginLeft: 1 }}
                    />
                    <Button
                        variant="outlined"
                        color="error"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={handleDeleteBox}
                    >
                        Delete Tile
                    </Button>
                    <Button onClick={() => setDialogOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            <CreateGameModal
                open={newGameDialogOpen}
                onClose={() => setNewGameDialogOpen(false)}
                studios={studios}
                initialGameName={newGameName}
                onGameCreated={handleGameCreated}
            />

            {/* Create New Master Promotion Dialog */}
            <Dialog disableScrollLock open={newPromoDialogOpen} onClose={() => setNewPromoDialogOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Create New Master Promotion</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Promotion Descriptive Text"
                        fullWidth
                        multiline
                        rows={3}
                        value={newPromoText}
                        onChange={(e) => setNewPromoText(e.target.value)}
                        placeholder="e.g. 50 Free Spins on Starburst when you deposit £10"
                        sx={{ mb: 3, mt: 1 }}
                    />
                    
                    {/* Tag/Category Selector */}
                    <Autocomplete
                        freeSolo
                        options={(() => {
                            const presetTags = [
                                'Sign Up Offer',
                                'Retention Offer',
                                'Game Promotion',
                                'Loyalty Scheme',
                                'Studio Promotion',
                                'Leaderboard or Tournament',
                                'Gamification',
                                'Prize Wheel or Prize Draw',
                                'Socials Follow CTA',
                                'Free Spins Offer',
                                'Cashback Offer',
                                'Responsible Gambling',
                                'Game Category Promotion',
                                'Other'
                            ];
                            return [...new Set([...presetTags, ...promotionTypes.map(t => t.PromotionType)])];
                        })()}
                        value={newPromoType}
                        onChange={(event, newValue) => {
                            setNewPromoType(newValue || 'Promotion');
                        }}
                        onInputChange={(event, newInputValue) => {
                            setNewPromoType(newInputValue || 'Promotion');
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Promotion Category / Tag"
                                placeholder="e.g. Sign Up Offer, Retention Offer"
                            />
                        )}
                        sx={{ mb: 3 }}
                    />

                    {/* Associated Games */}
                    <Autocomplete
                        multiple
                        fullWidth
                        options={games}
                        filterSelectedOptions
                        filterOptions={(options, state) => {
                            const inputValue = (state.inputValue || '').toLowerCase().trim();
                            const unselectedOptions = options.filter(option => 
                                !newPromoAssociatedGames.includes(option.GameID)
                            );
                            if (!inputValue) {
                                return unselectedOptions.slice(0, 100);
                            }
                            const filtered = unselectedOptions.filter(option => 
                                (option.Name || '').toLowerCase().includes(inputValue)
                            );
                            filtered.sort((a, b) => {
                                const aName = (a.Name || '').toLowerCase();
                                const bName = (b.Name || '').toLowerCase();
                                const aStarts = aName.startsWith(inputValue);
                                const bStarts = bName.startsWith(inputValue);
                                if (aStarts && !bStarts) return -1;
                                if (!aStarts && bStarts) return 1;
                                return aName.localeCompare(bName);
                            });
                            return filtered.slice(0, 100);
                        }}
                        getOptionLabel={(option) => option.Name || ''}
                        value={newPromoAssociatedGamesObjects}
                        onChange={(event, newValue) => setNewPromoAssociatedGames(newValue.map(g => g.GameID))}
                        isOptionEqualToValue={(option, value) => option.GameID === value.GameID}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Associated Games (Optional)"
                                placeholder="Select games featured in this promotion"
                            />
                        )}
                        sx={{ mb: 3 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setNewPromoDialogOpen(false)}>Cancel</Button>
                    <Button
                        onClick={handleCreateNewPromotion}
                        variant="contained"
                        color="secondary"
                        disabled={!newPromoText}
                    >
                        Create &amp; Assign
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Search Dialog */}
            <Dialog disableScrollLock open={searchDialogOpen} onClose={() => setSearchDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Search Pending Matches</DialogTitle>
                <DialogContent>
                    <Box mt={2}>
                        <TextField
                            autoFocus
                            label="Search by Game ID or Name"
                            fullWidth
                            variant="outlined"
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)}
                            helperText={`Found ${searchResults.length} matches`}
                        />
                    </Box>
                    {searchResults.length > 0 && (
                        <Box mt={2} maxHeight="200px" overflow="auto" border="1px solid #eee" borderRadius={1}>
                            {searchResults.map((box, idx) => {
                                const gameID = box.ConfirmedMatch?.M?.GameID?.S || box.GameID?.S || '';
                                const gameName = games.find(g => g.GameID === gameID)?.Name || 'Unknown Game';
                                const analysedText = box.AnalysedText?.M?.GameName?.S;
                                const ocrText = box.RecognizedText?.S;

                                return (
                                    <Box
                                        key={idx}
                                        p={1}
                                        borderBottom="1px solid #eee"
                                        onClick={() => {
                                            setNavigationMode('search');
                                            handleBoxClick(box, true);
                                            setSearchDialogOpen(false);
                                        }}
                                        sx={{
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#f5f5f5'
                                            }
                                        }}
                                    >
                                        <Typography variant="body2" fontWeight="bold">{gameName}</Typography>
                                        {(analysedText || ocrText) && (
                                            <Typography variant="caption" display="block" color="textSecondary">
                                                Detected: {analysedText || ocrText}
                                            </Typography>
                                        )}
                                        <Typography variant="caption" color="textSecondary">{box.BoundingBoxID?.S} | {gameID}</Typography>
                                    </Box>
                                )
                            })}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleTakeMeThere}
                        color="primary"
                        variant="contained"
                        disabled={searchResults.length !== 1}
                    >
                        Take Me There
                    </Button>
                    <Button onClick={() => setSearchDialogOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            {/* Floating Action Menu */}
            {currentScreenshot && (
                <Box
                    sx={{
                        position: 'fixed',
                        right: 24,
                        bottom: 24,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        zIndex: 1100,
                        alignItems: 'flex-end',
                        pointerEvents: 'none' // Allows drawing boxes behind the menu
                    }}
                >
                    {/* Batch Delete Toggle */}
                    <Box sx={{ pointerEvents: 'none', display: 'flex', alignItems: 'center', position: 'relative', '&:hover .label': { opacity: 1, transform: 'translateX(0)' } }}>
                        <Typography 
                            className="label"
                            sx={{ 
                                opacity: 0, 
                                transform: 'translateX(10px)', 
                                transition: 'all 0.2s ease', 
                                backgroundColor: 'rgba(0,0,0,0.8)', 
                                color: 'white', 
                                px: 1.5, 
                                py: 0.5, 
                                borderRadius: 1, 
                                position: 'absolute',
                                right: '100%',
                                mr: 2,
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                fontSize: '0.875rem'
                            }}
                        >
                            {batchDeleteMode 
                                ? (selectedBoxes.length > 0 ? `Delete ${selectedBoxes.length} Selected` : "Exit Batch Delete [D]") 
                                : "Batch Delete Mode [D]"}
                        </Typography>
                        <IconButton
                            onClick={() => {
                                if (batchDeleteMode) {
                                    if (selectedBoxes.length > 0) {
                                        handleBatchDelete();
                                    } else {
                                        setBatchDeleteMode(false);
                                    }
                                } else {
                                    setBatchDeleteMode(true);
                                    setDrawMode(false);
                                }
                            }}
                            sx={{
                                pointerEvents: 'auto',
                                backgroundColor: batchDeleteMode ? '#f44336' : '#1976d2',
                                color: 'white',
                                width: 56,
                                height: 56,
                                boxShadow: 3,
                                '&:hover': { 
                                    backgroundColor: batchDeleteMode ? '#d32f2f' : '#1565c0',
                                    transform: 'scale(1.05)'
                                }
                            }}
                        >
                            <DeleteSweepIcon />
                        </IconButton>
                    </Box>

                    {/* Draw Mode Toggles */}
                    {drawMode && drawBoxType === 'GameGroup' && (
                        <Box sx={{ pointerEvents: 'none', display: 'flex', alignItems: 'center', position: 'relative', '&:hover .label': { opacity: 1, transform: 'translateX(0)' } }}>
                            <Typography 
                                className="label"
                                sx={{ 
                                    opacity: 0, 
                                    transform: 'translateX(10px)', 
                                    transition: 'all 0.2s ease', 
                                    backgroundColor: 'rgba(0,0,0,0.8)', 
                                    color: 'white', 
                                    px: 1.5, 
                                    py: 0.5, 
                                    borderRadius: 1, 
                                    position: 'absolute',
                                    right: '100%',
                                    mr: 2,
                                    whiteSpace: 'nowrap',
                                    pointerEvents: 'none',
                                    fontSize: '0.875rem'
                                }}
                            >
                                {isCloning ? "Cloning..." : "Clone Previous Day Groups"}
                            </Typography>
                            <IconButton
                                onClick={handleClonePreviousItems}
                                disabled={isCloning || currentScreenshotIndex >= screenshots.length - 1}
                                sx={{
                                    pointerEvents: 'auto',
                                    backgroundColor: '#4caf50',
                                    color: 'white',
                                    width: 56,
                                    height: 56,
                                    boxShadow: 3,
                                    '&:hover': { 
                                        backgroundColor: '#388e3c',
                                        transform: 'scale(1.05)'
                                    },
                                    '&.Mui-disabled': {
                                        backgroundColor: '#a5d6a7',
                                        color: 'rgba(255,255,255,0.7)'
                                    }
                                }}
                            >
                                {isCloning ? <CircularProgress size={24} color="inherit" /> : <CloneIcon />}
                            </IconButton>
                        </Box>
                    )}
                    <Box sx={{ pointerEvents: 'none', display: 'flex', alignItems: 'center', position: 'relative', '&:hover .label': { opacity: 1, transform: 'translateX(0)' } }}>
                        <Typography 
                            className="label"
                            sx={{ 
                                opacity: 0, 
                                transform: 'translateX(10px)', 
                                transition: 'all 0.2s ease', 
                                backgroundColor: 'rgba(0,0,0,0.8)', 
                                color: 'white', 
                                px: 1.5, 
                                py: 0.5, 
                                borderRadius: 1, 
                                position: 'absolute',
                                right: '100%',
                                mr: 2,
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                fontSize: '0.875rem'
                            }}
                        >
                            {drawMode && drawBoxType === 'GameGroup' ? "Exit Draw Group [O]" : "Draw Game Group [O]"}
                        </Typography>
                        <IconButton
                            onClick={() => {
                                if (drawMode && drawBoxType === 'GameGroup') {
                                    setDrawMode(false);
                                } else {
                                    setDrawMode(true);
                                    setDrawBoxType('GameGroup');
                                    setBatchDeleteMode(false);
                                }
                            }}
                            sx={{
                                pointerEvents: 'auto',
                                backgroundColor: drawMode && drawBoxType === 'GameGroup' ? '#ffeb3b' : '#1976d2',
                                color: drawMode && drawBoxType === 'GameGroup' ? 'black' : 'white',
                                width: 56,
                                height: 56,
                                boxShadow: 3,
                                '&:hover': { 
                                    backgroundColor: drawMode && drawBoxType === 'GameGroup' ? '#fdd835' : '#1565c0',
                                    transform: 'scale(1.05)'
                                }
                            }}
                        >
                            <GroupWorkIcon />
                        </IconButton>
                    </Box>
 
                    {/* Clone Previous Day Promotions Feature - Only visible in promotion draw mode */}
                    {drawMode && drawBoxType === 'Promotion' && (
                        <Box sx={{ pointerEvents: 'none', display: 'flex', alignItems: 'center', position: 'relative', '&:hover .label': { opacity: 1, transform: 'translateX(0)' } }}>
                            <Typography 
                                className="label"
                                sx={{ 
                                    opacity: 0, 
                                    transform: 'translateX(10px)', 
                                    transition: 'all 0.2s ease', 
                                    backgroundColor: 'rgba(0,0,0,0.8)', 
                                    color: 'white', 
                                    px: 1.5, 
                                    py: 0.5, 
                                    borderRadius: 1, 
                                    position: 'absolute',
                                    right: '100%',
                                    mr: 2,
                                    whiteSpace: 'nowrap',
                                    pointerEvents: 'none',
                                    fontSize: '0.875rem'
                                }}
                            >
                                {isCloning ? "Cloning..." : "Clone Previous Day Promotions"}
                            </Typography>
                            <IconButton
                                onClick={() => handleClonePreviousItems('Promotion')}
                                disabled={isCloning || currentScreenshotIndex >= screenshots.length - 1}
                                sx={{
                                    pointerEvents: 'auto',
                                    backgroundColor: '#4caf50',
                                    color: 'white',
                                    width: 56,
                                    height: 56,
                                    boxShadow: 3,
                                    '&:hover': { 
                                        backgroundColor: '#388e3c',
                                        transform: 'scale(1.05)'
                                    },
                                    '&.Mui-disabled': {
                                        backgroundColor: '#a5d6a7',
                                        color: 'rgba(255,255,255,0.7)'
                                    }
                                }}
                            >
                                {isCloning ? <CircularProgress size={24} color="inherit" /> : <CloneIcon />}
                            </IconButton>
                        </Box>
                    )}

                    {/* Draw Promotion Toggle */}
                    <Box sx={{ pointerEvents: 'none', display: 'flex', alignItems: 'center', position: 'relative', '&:hover .label': { opacity: 1, transform: 'translateX(0)' } }}>
                        <Typography 
                            className="label"
                            sx={{ 
                                opacity: 0, 
                                transform: 'translateX(10px)', 
                                transition: 'all 0.2s ease', 
                                backgroundColor: 'rgba(0,0,0,0.8)', 
                                color: 'white', 
                                px: 1.5, 
                                py: 0.5, 
                                borderRadius: 1, 
                                position: 'absolute',
                                right: '100%',
                                mr: 2,
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                fontSize: '0.875rem'
                            }}
                        >
                            {drawMode && drawBoxType === 'Promotion' ? "Exit Draw Promotion [P]" : "Draw Promotion Box [P]"}
                        </Typography>
                        <IconButton
                            onClick={() => {
                                if (drawMode && drawBoxType === 'Promotion') {
                                    setDrawMode(false);
                                } else {
                                    setDrawMode(true);
                                    setDrawBoxType('Promotion');
                                    setBatchDeleteMode(false);
                                }
                            }}
                            sx={{
                                pointerEvents: 'auto',
                                backgroundColor: drawMode && drawBoxType === 'Promotion' ? '#9c27b0' : '#1976d2',
                                color: 'white',
                                width: 56,
                                height: 56,
                                boxShadow: 3,
                                '&:hover': { 
                                    backgroundColor: drawMode && drawBoxType === 'Promotion' ? '#7b1fa2' : '#1565c0',
                                    transform: 'scale(1.05)'
                                }
                            }}
                        >
                            <CampaignIcon />
                        </IconButton>
                    </Box>

                    {/* Draw Game Toggle */}
                    <Box sx={{ pointerEvents: 'none', display: 'flex', alignItems: 'center', position: 'relative', '&:hover .label': { opacity: 1, transform: 'translateX(0)' } }}>
                        <Typography 
                            className="label"
                            sx={{ 
                                opacity: 0, 
                                transform: 'translateX(10px)', 
                                transition: 'all 0.2s ease', 
                                backgroundColor: 'rgba(0,0,0,0.8)', 
                                color: 'white', 
                                px: 1.5, 
                                py: 0.5, 
                                borderRadius: 1, 
                                position: 'absolute',
                                right: '100%',
                                mr: 2,
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                fontSize: '0.875rem'
                            }}
                        >
                            {drawMode && drawBoxType === 'Game' ? "Exit Draw Mode [G]" : "Draw Bounding Box [G]"}
                        </Typography>
                        <IconButton
                            onClick={() => {
                                if (drawMode && drawBoxType === 'Game') {
                                    setDrawMode(false);
                                } else {
                                    setDrawMode(true);
                                    setDrawBoxType('Game');
                                    setBatchDeleteMode(false);
                                }
                            }}
                            sx={{
                                pointerEvents: 'auto',
                                backgroundColor: drawMode && drawBoxType === 'Game' ? '#4caf50' : '#1976d2',
                                color: 'white',
                                width: 56,
                                height: 56,
                                boxShadow: 3,
                                '&:hover': { 
                                    backgroundColor: drawMode && drawBoxType === 'Game' ? '#388e3c' : '#1565c0',
                                    transform: 'scale(1.05)'
                                }
                            }}
                        >
                            <SquareIcon />
                        </IconButton>
                    </Box>

                    {/* Refresh Button */}
                    <Box sx={{ pointerEvents: 'none', display: 'flex', alignItems: 'center', position: 'relative', '&:hover .label': { opacity: 1, transform: 'translateX(0)' } }}>
                        <Typography 
                            className="label"
                            sx={{ 
                                opacity: 0, 
                                transform: 'translateX(10px)', 
                                transition: 'all 0.2s ease', 
                                backgroundColor: 'rgba(0,0,0,0.8)', 
                                color: 'white', 
                                px: 1.5, 
                                py: 0.5, 
                                borderRadius: 1, 
                                mr: 2, 
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                fontSize: '0.875rem'
                            }}
                        >
                            Refresh Analysis [R]
                        </Typography>
                        <IconButton
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={handleManualRefresh}
                            disabled={isRefreshing}
                            sx={{
                                pointerEvents: 'auto',
                                backgroundColor: '#1976d2',
                                color: 'white',
                                width: 56,
                                height: 56,
                                boxShadow: 3,
                                '&:hover': { 
                                    backgroundColor: '#1565c0',
                                    transform: 'scale(1.05)'
                                },
                                '&.Mui-disabled': { backgroundColor: '#ccc', color: '#666' }
                            }}
                        >
                            {isRefreshing ? <CircularProgress size={24} color="inherit" /> : <RefreshIcon />}
                        </IconButton>
                    </Box>
                </Box>
            )}

            {/* Game Group Naming Dialog */}
            <Dialog 
                disableScrollLock
                open={groupNameDialogOpen} 
                onClose={() => {
                    setGroupNameDialogOpen(false);
                    setNewGroupBox(null);
                }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Name Game Group</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        Enter a name for this group (e.g., "Jackpots", "New Games", "Pragmatic Play").
                        This group contains <strong>{newGroupBox?.children?.length || 0}</strong> child tiles.
                    </Typography>
                    <Autocomplete
                        freeSolo
                        open={groupNameAutocompleteOpen}
                        onOpen={() => setGroupNameAutocompleteOpen(true)}
                        onClose={() => setGroupNameAutocompleteOpen(false)}
                        options={(() => {
                            const site = websiteCatalog.find(s => s.WebsitesDBID === selectedWebsiteId);
                            if (!site || !site.KnownGroupNames) return [];
                            if (Array.isArray(site.KnownGroupNames)) return site.KnownGroupNames;
                            if (site.KnownGroupNames.L) return site.KnownGroupNames.L.map(i => i.S);
                            if (site.KnownGroupNames.SS) return site.KnownGroupNames.SS;
                            return [];
                        })()}
                        value={groupName}
                        onChange={(event, newValue) => setGroupName(newValue ? newValue.toLowerCase() : '')}
                        onInputChange={(event, newInputValue) => setGroupName(newInputValue ? newInputValue.toLowerCase() : '')}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                inputRef={groupNameInputRef}
                                autoFocus
                                label="Group Name"
                                variant="outlined"
                                fullWidth
                                onKeyDown={(e) => {
                                    // Prevent saving when Enter is used to select an option from the dropdown
                                    if (e.key === 'Enter' && !groupNameAutocompleteOpen && !e.defaultPrevented && groupName.trim()) {
                                        e.preventDefault();
                                        handleSaveGameGroup();
                                    }
                                }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setGroupNameDialogOpen(false);
                        setNewGroupBox(null);
                    }}>Cancel</Button>
                    <Button 
                        type="button"
                        onClick={(e) => {
                            e.preventDefault();
                            handleSaveGameGroup();
                        }} 
                        variant="contained" 
                        color="primary"
                        disabled={!groupName.trim()}
                    >
                        Save Group
                    </Button>
                </DialogActions>
            </Dialog>

            {/* What's New Dialog */}
            <Dialog 
                open={whatsNewOpen} 
                onClose={handleCloseWhatsNew}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: 24,
                        p: 1
                    }
                }}
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <span>✨</span> {language === 'en' ? "What's New in Time Machine!" : "Novidades do Time Machine!"}
                    </Typography>
                    <ToggleButtonGroup
                        value={language}
                        exclusive
                        onChange={(e, val) => val && setLanguage(val)}
                        size="small"
                        sx={{
                            '& .MuiToggleButton-root': {
                                py: 0.2,
                                px: 1.5,
                                fontSize: '1.2rem',
                                borderRadius: '8px',
                            }
                        }}
                    >
                        <ToggleButton value="en" title="English">🇬🇧</ToggleButton>
                        <ToggleButton value="pt" title="Português (Brasil)">🇧🇷</ToggleButton>
                    </ToggleButtonGroup>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                        {language === 'en' 
                            ? "We're capturing manual correction data to power our smart anomaly detection algorithms!"
                            : "Estamos capturando dados de correção manual para alimentar nossos algoritmos inteligentes de detecção de anomalias!"
                        }
                    </Typography>
                    
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                            <Box sx={{ fontSize: '1.75rem', bgcolor: 'rgba(25, 118, 210, 0.1)', p: 1, borderRadius: 2, lineHeight: 1 }}>
                                📋
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                                    {language === 'en' ? "Add to Review List on Reassignment" : "Adicionar à Lista de Revisão ao Reatribuir"}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {language === 'en' ? (
                                        <>When you manually reassign a game to fix an AI mismatch, you will now be prompted to automatically add the original misidentified game to an <strong>Anomaly Review List</strong>. In the background, we are now capturing all reassignment data so in the future we can spot trends and automatically generate Review Lists for you!</>
                                    ) : (
                                        <>Ao reatribuir manualmente um jogo para corrigir um erro da IA, você será solicitado a adicionar automaticamente o jogo identificado incorretamente a uma <strong>Lista de Revisão de Anomalias</strong>. Em segundo plano, agora estamos capturando todos os dados de reatribuição para que, no futuro, possamos identificar tendências e gerar automaticamente Listas de Revisão para você!</>
                                    )}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
                    <Button 
                        onClick={handleDontShowWhatsNew} 
                        sx={{ textTransform: 'none', color: '#666' }}
                    >
                        {language === 'en' ? "Exit, and Don't Show Again" : "Sair e Não Mostrar Novamente"}
                    </Button>
                    <Button 
                        variant="contained" 
                        onClick={handleCloseWhatsNew}
                        sx={{ px: 3, borderRadius: 2 }}
                    >
                        {language === 'en' ? "Exit" : "Sair"}
                    </Button>
                </DialogActions>
            </Dialog>

            <AddToAnomalyListModal 
                open={anomalyListModalOpen} 
                onClose={() => setAnomalyListModalOpen(false)} 
                gameId={lastOriginalGameId || (selectedBox?.GameID?.S || selectedBox?.GameID)} 
            />

        </View >
    );
};

export default withAuthenticator(TimeMachine);
